import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { BehaviorSubject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  finalize,
  map,
  switchMap,
  tap,
  filter,
  take,
} from "rxjs/operators";
import { EventService } from "src/app/core/services/event.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import {
  PropertyFiltersModel,
  PropertyModel,
  PropertyPreviewModel,
} from "../models/property.model";
import { PropertySavedFilterApplyEvent } from "../models/property-saved-filter.model";
import { PropertiesService } from "../services/properties.services";
import { TranslateService } from "@ngx-translate/core";
// Range Slider
import { Options, LabelType } from "@angular-slider/ngx-slider";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { MenuService } from "src/app/core/services/menu.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { ToastService } from "src/app/shared/toasts/toast-service";
import { TopBarService } from "src/app/layouts/topbar/services/top-bar.services";
import { AgencyContextService } from "src/app/core/services/agency-context.service";
import {
  NgbCarousel,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
  NgbNav,
} from "@ng-bootstrap/ng-bootstrap";
import { IAlbum, Lightbox, LightboxEvent, LIGHTBOX_EVENT } from "ngx-lightbox";
import { EntityService } from "../../entity/services/entity.service";
import { ShowcaseLayoutModel } from "src/app/shared/models/showcase-layout.model";
import { NgxEchartsModule } from "ngx-echarts";
import { ActivatedRoute, Router } from "@angular/router";
import { ActivityLogsService } from "src/app/core/services/logs.service";

/** Linha de uma tabela da ficha rápida (Proprietário, Oportunidades, Visitas). */
interface PropertyDetailsRow {
  id: string;
  kind: "owner" | "opportunity" | "visit";
  name: string;
  initials: string;
  subtitle: string | null;
  extra: string | null;
  statusKey: string | null;
  statusText: string | null;
  statusTone: "success" | "danger" | "warning" | "primary" | "muted";
  statusIcon: string;
  agentName: string | null;
  agentInitials: string | null;
  dateLabel: string | null;
  dateTitle: any;
  source: any;
}

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class ListComponent implements OnInit, AfterViewInit, OnDestroy {
  typologies: any[] = [
    { id: 0, name: "T0" },
    { id: 1, name: "T1" },
    { id: 2, name: "T2" },
    { id: 3, name: "T3" },
    { id: 4, name: "T4" },
    { id: 5, name: "T5" },
    { id: 6, name: "T6" },
    { id: 7, name: "T7" },
    { id: 8, name: "T8" },
    { id: 9, name: "T9" },
    { id: 10, name: "T10+" },
  ];
  locations: any[] = [];
  @ViewChild("button_close_property_filters")
  closePropertyfiltersRef!: ElementRef;
  breadCrumbItems!: Array<{}>;
  properties!: PropertyModel[];
  hideElement: boolean = true;
  queryField = new FormControl();
  referenceQueryField = new FormControl();
  total: number = 0;
  page: number = 1;
  pageSize: number = 10;
  startIndex: number = 1;
  endIndex: number = 10;
  filter: string = "";
  masterSelected!: boolean;
  pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
  pathUserImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  noresult: boolean = false;
  countCheckSelected = 0;
  checkedList: any;
  property: any;
  isOpenModal = false;
  openModaltSubject$!: BehaviorSubject<number>;
  dataToFormInitDetails: any;
  dataToFormInitAddress: any;
  dataToFormInitAreasNearby: any;
  dataToFormInitChar: any;
  dataToFormInitAdvertisement: any;
  dataToFormInitContacts: any;
  dataToFormInitAgents: any;
  dataToFormInitPortals: any;
  statusList: any;
  selectedStatusId: number | null = null;
  hasStatusFilter = false;
  appliedSavedFilterId: string | null = null;
  appliedSavedFilterName: string | null = null;
  activeFilterChips: any[] = [];
  statusFilterLabel = "";
  locationFilterLabel = "";
  typologyFilterLabel = "";
  propertyTypeFilterLabel = "";
  currentSavedFilterFormValue: Record<string, any> | null = null;
  minPrice = 0;
  maxPrice = 0;
  options!: Options;
  propertyTypes: any = [];
  propertyTypeGroups: Array<{ name: string; items: any[] }> = [];
  conditions: any = [];
  businessStatus: Array<{ id: number; code?: string; description: string }> =
    [];
  filtersBusinessStatus: Array<{
    id: number;
    code?: string;
    description: string;
  }> = [];
  ecs: any = [];
  businessTypes: any = [];
  stores: any = [];
  /** Agência fixada pelo contexto global do topbar (vazio sem contexto). */
  lockedStores: number[] = [];
  agents: any = [];
  agentsAux: any = [];
  districts: any[] = [];
  counties: any[] = [];
  parish: any[] = [];
  propertiesFiltersForm!: FormGroup;
  countFilters$!: BehaviorSubject<number>;
  countFiltersconditions: number = 0;
  countFiltersBusinessStatus: number = 0;
  countFiltersBusinessTypes: number = 0;
  countFiltersECS: number = 0;
  propertyFilters!: PropertyFiltersModel;
  showPropertyFilerts = false;
  isLoadingList = false;
  isCountPropertyFilters = false;
  totalPropertyFilters = 0;
  canActivateProperties: { available: boolean; quantity: number } = {
    available: false,
    quantity: 0,
  };
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any[];
    associatedUsers?: any;
  };
  bkpFiltersForm: any;
  autoReference = false;
  subscriptions: Subscription = new Subscription();
  openProposal: any;
  openDetails: any;
  prospectingId: any;
  // @Input()
  // portalListErrors: any;
  // @Input()
  // portalIdErrors!: number
  @Input()
  portalExportError!: any;
  totalExported: number = 0;
  nabTabActive: number = 1;
  allData: any;
  receiveNotifictionsImagesProcessed!: Subscription;
  receiveNotifictionsUnitsProcessed!: Subscription;
  receiveNotifictionsImagesProgress!: Subscription;
  toastsTitle: any;
  toastsText: any;
  toastsPercentage: any;
  showToasts = false;
  propertyToUpdate: any;
  sortColumn:
    | "property"
    | "propertyType"
    | "businessType"
    | "price"
    | "store"
    | "status"
    | "updated"
    | "createdAt"
    | null = null;
  sortDirection: "asc" | "desc" = "asc";

  modalPreviewRef!: NgbModalRef;
  /** Preview de fração aberto por cima do preview do empreendimento. */
  private fractionPreviewFromDev = false;
  modalMontraRef!: NgbModalRef;

  selectedProperty: any = null;
  selectedModalTab: string = "owner";
  modalRef: NgbModalRef | null = null;

  dataProperty: any[] = [];

  entityId: any;
  pendingAutoOpenPropertyId: number | string | null = null;
  autoOpenPropertyProcessed: boolean = false;



  @Input()
  openCreateProperty: boolean = false;
  @Input() openPreview: string | null = null;
  @Input() allowEditFromEmbeddedPreview: boolean = false;
  @Input() autoOpenEditFromPreview: boolean = false;
  /**
   * Separador do formulário a abrir quando `autoOpenEditFromPreview` salta
   * directamente para a edição (a página de angariação aponta para a secção
   * do campo em falta). Passa ao `<app-create-edit>` como `openTab`.
   */
  @Input() autoOpenEditTab: number | null = null;
  /**
   * Modo embebido: o utilizador clicou "Editar imóvel" dentro do preview. O
   * `modal.dismiss()` desse clique NÃO pode emitir `closeModalPreview` — o
   * pai (página do deal) destruiria o `<app-list>` inteiro antes de o
   * formulário de edição chegar a abrir. O emit fica adiado para o fecho do
   * formulário (evento `is-open-modal-properties` false), como no modo
   * `autoOpenEditFromPreview`.
   */
  private editingFromEmbeddedPreview = false;
  @Output() closeModalPreview: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @ViewChild("modalPreview") modalPreview!: NgbModal;
  @ViewChild("modalMontra") modalMontra!: NgbModal;
  @ViewChild("propertyNotesFileInput")
  propertyNotesFileInput?: ElementRef<HTMLInputElement>;

  propertyToPreview!: PropertyPreviewModel;
  fullPropertyToPreview: any;
  activeSliderId = "ngb-slide-0";
  /** Imagem do preview aberta inteira (lightbox) — o Esc fecha-a sem fechar o preview. */
  private previewLightboxOpen = false;
  /** Início do toque na galeria do preview (deslizar para mudar de imagem). */
  private previewTouchStart: { x: number; y: number } | null = null;
  pathDocuments = `${environment.apiUrl}${environment.dirPropertiesDocs}/`;
  enablePropertyNotes: boolean = false;
  showMinCommissionPendingFilter: boolean = false;
  showOutdatedParishFilter: boolean = false;
  propertyNotesExpanded: boolean = false;
  propertyNotesLoading: boolean = false;
  propertyNotesSaving: boolean = false;
  propertyNotes: any[] = [];
  newPropertyNote: string = "";
  /** O que o servidor deixa fazer nas notas do imóvel em preview. */
  propertyNotesAccess: { canRead: boolean; canWrite: boolean } | null = null;
  propertyNoteFilesToUpload: File[] = [];

  requiredOwner: boolean = false;
  allStores: any[] = [];
  storesAux: any[] = [];
  districtsAux: any[] = [];
  allDistricts: any[] = [];
  scopeOptions: any[] = [];
  selectedScope: string | null = null;
  montraForm!: FormGroup;
  isLoadingShowcase: boolean = false;
  showcaseLayouts: ShowcaseLayoutModel[] = [];
  showcaseLayoutsLoading: boolean = false;
  selectedShowcaseLayout: ShowcaseLayoutModel | null = null;

  constructor(
    private propertiesService: PropertiesService,
    private eventService: EventService,
    public translate: TranslateService,
    private formBuilder: FormBuilder,
    public permissionsService: PermissionsService,
    private menuService: MenuService,
    private notificationService: NotificationService,
    public toastService: ToastService,
    private topBarService: TopBarService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private entityService: EntityService,
    private route: ActivatedRoute,
    private router: Router,
    private lightbox: Lightbox,
    private lightboxEvent: LightboxEvent,
    private activityLogsService: ActivityLogsService,
    private agencyContext: AgencyContextService,
  ) {
    // Agência do topbar: o filtro por agência começa nela e fica bloqueado. A
    // página é recriada a cada troca, por isso basta lê-la aqui.
    const agencyStoreId = this.agencyContext.storeId;
    this.lockedStores = agencyStoreId ? [agencyStoreId] : [];
    this.openModaltSubject$ = new BehaviorSubject<number>(0);
    this.countFilters$ = new BehaviorSubject<number>(0);
  }

  ngOnInit(): void {
    /* BreadCrumb */
    this.breadCrumbItems = [
      { label: "Properties" },
      { label: "Properties List", active: true },
    ];
    this.setPendingAutoOpenPropertyFromQuery();

    const waitForSync = this.topBarService.waitForSync().subscribe(() => {
      this.propertyFilters = {
        page: this.page,
      };
      this.applyAgencyStoreLock();
      if (this.portalExportError?.id && this.portalExportError?.status) {
        this.propertyFilters.exportId = this.portalExportError?.id;
        this.propertyFilters.isExported = this.portalExportError?.isExported;
        this.propertyFilters.status = true;
      }

      const { id, role, stores, associatedUsers } =
        this.propertiesService.getUserAuth();
      this.loginUser = { id, role, stores, associatedUsers };
      this.loadEntitySettings();
      this.loadOutdatedParishFilterVisibility();
      this.loadShowcaseLayouts();
      this.searchData();

      if (!this.openPreview) {
        this.loadData();
      }

      const subscriptionRefresh = this.eventService.subscribe(
        "refresh-properties",
        () => {
          this.refreshProperties();
        },
      );
      this.subscriptions.add(subscriptionRefresh);

      const subscriptionR = this.eventService.subscribe(
        "is-open-modal-properties",
        (value) => {
          this.openModaltSubject$.next(5);
          this.isOpenModal = false;
          if (
            value === false &&
            !!this.openPreview &&
            (this.autoOpenEditFromPreview || this.editingFromEmbeddedPreview)
          ) {
            this.editingFromEmbeddedPreview = false;
            this.closeModalPreview.emit(true);
          }
        },
      );
      this.subscriptions.add(subscriptionR);
      this.tabAll();

      const menuSubs = this.eventService.subscribe(
        "menu-proposals",
        (menuData) => {
          if (menuData && menuData.propertyId) {
            if (menuData.id) {
              this.openProposal = menuData.id;
              let l: any = this.properties.find((property: any) => {
                return property.id === menuData.propertyId;
              });
              if (l) {
                this.openModal(l);
              } else {
                this.propertiesService
                  .findPrevById(menuData.propertyId)
                  .subscribe((property: any) => {
                    if (property && property?.propertyType?.type !== 1) {
                      this.openModal(property);
                    } else {
                      this.nabTabActive = 2;
                      setTimeout(() => {
                        this.eventService.broadcast("open-proposal-dev", {
                          property,
                          proposalId: menuData.id,
                        });
                      });
                    }
                  });
              }
            } else {
              this.errorMsg(this.translate.instant("t-proposal-no-available"));
            }
          }
          this.menuService.setData(null);
        },
      );

      const openDetails = this.eventService.subscribe("open-details", () =>
        setTimeout(() => {
          this.openDetails = null;
        }),
      );

      const menuDetails = this.eventService.subscribe(
        "menu-details",
        (menuData) => {
          if (menuData && menuData.propertyId) {
            if (menuData.id) {
              this.openDetails = menuData.id;

              let l: any = this.properties.find((property: any) => {
                return property.id === menuData.propertyId;
              });

              if (l) {
                this.openModal(l);
              } else {
                this.propertiesService
                  .findPrevById(menuData.propertyId)
                  .subscribe((property: any) => {
                    if (property && property?.propertyType?.type !== 1) {
                      this.openModal(property);
                    } else {
                      this.nabTabActive = 2;
                      setTimeout(() => {
                        this.eventService.broadcast("open-details-dev", {
                          property,
                          propertyId: menuData.id,
                        });
                      });
                    }
                  });
              }
            } else {
              this.errorMsg(this.translate.instant("t-details-no-available"));
            }
          }
          this.menuService.setData(null);
        },
      );

      const clearOpenProposal = this.eventService.subscribe(
        "clear-open-proposal",
        () =>
          setTimeout(() => {
            this.openProposal = null;
          }),
      );

      const fractionSub = this.eventService.subscribe(
        "open-fraction-by-dev",
        (id) => {
          if (id) {
            this.propertiesService.findPrevById(id).subscribe((property) => {
              if (property) {
                this.openModal(property);
                document.querySelector(".modal-dev")?.classList.remove("show");
                document
                  .querySelector(".modal-back-dev")
                  ?.classList.remove("show");
                const closeSubscribe = this.eventService.subscribe(
                  "is-open-modal-properties",
                  (value) => {
                    if (value === false) {
                      closeSubscribe.unsubscribe();
                      document
                        .querySelector(".modal-dev")
                        ?.classList.add("show");
                      document
                        .querySelector(".modal-back-dev")
                        ?.classList.add("show");
                    }
                  },
                );
              }
            });
          }
          this.menuService.setData(null);
        },
      );

      // Duplo clique numa fração no preview do empreendimento: abre o preview
      // da fração por cima do do empreendimento.
      const fractionPreviewSub = this.eventService.subscribe(
        "open-fraction-preview-by-dev",
        (id) => {
          if (!id) return;
          this.propertiesService.findPrevById(id).subscribe((property: any) => {
            if (property?.preview) {
              this.fractionPreviewFromDev = true;
              this.openPreviewModal(this.modalPreview, property).hidden.subscribe(
                () => (this.fractionPreviewFromDev = false),
              );
            }
          });
        },
      );

      this.subscriptions.add(menuSubs);
      this.subscriptions.add(menuDetails);
      this.subscriptions.add(fractionSub);
      this.subscriptions.add(fractionPreviewSub);
      this.subscriptions.add(clearOpenProposal);
      this.subscriptions.add(openDetails);
      this.initScopeOptions();
    });

    this.montraForm = this.formBuilder.group({
      title: ["", [Validators.required, Validators.maxLength(20)]],
      subTitle: ["", [Validators.maxLength(25)]],
      description: ["", [Validators.required, Validators.maxLength(200)]],
      templateType: ["vertical"],
      layoutId: [null],
      layoutCode: [null],
      agentName: [null],
      price: [null],
      agentPhone: [null],
      agentEmail: [null],
      reference: [null],
      energeticClass: [null],
      area: [null],
      zone: [null, [Validators.maxLength(30)]],
      ami: [null],
      images: this.formBuilder.array([]),
      agentImage: [null],
      propertyId: [null],
      storeId: [null],
      appId: [null],
      companyName: [null]
    });

    const defaultLayout = this.getDefaultShowcaseLayout();
    if (defaultLayout) {
      this.selectShowcaseLayout(defaultLayout, false);
    }

    this.subscriptions.add(waitForSync);
  }

  ngAfterViewInit() {
    this.loadJs();

    this.translate.onLangChange.subscribe(() => {
      this.tabAll();
      this.refreshProperties();
    });

    if (!this.receiveNotifictionsImagesProcessed) {
      this.receiveNotifictionsImagesProcessed = this.notificationService
        .receiveNotifictionsImagesProcessed()
        .subscribe((data) => {
          this.refreshProperties();
        });
      this.subscriptions.add(this.receiveNotifictionsImagesProcessed);
    }

    if (!this.receiveNotifictionsUnitsProcessed) {
      this.receiveNotifictionsUnitsProcessed = this.notificationService
        .receiveNotifictionsUnitsProcessed()
        .subscribe((data) => {
          this.refreshProperties();
        });
      this.subscriptions.add(this.receiveNotifictionsUnitsProcessed);
    }

    if (!this.receiveNotifictionsImagesProgress) {
      this.receiveNotifictionsImagesProgress = this.notificationService
        .receiveNotifictionsImagesProgress()
        .subscribe((data) => {
          if (data <= 100) {
            this.showToasts = true;
            this.toastsTitle = "A Processar...";
            this.toastsText = `${data}%`;
            this.toastsPercentage = data;
            if (data === 100)
              setTimeout(() => {
                this.showToasts = false;
                this.toastsTitle = undefined;
                this.toastsText = undefined;
                this.toastsPercentage = undefined;
              }, 500);
          } else {
            this.showToasts = false;
            this.toastsTitle = undefined;
            this.toastsText = undefined;
            this.toastsPercentage = undefined;
          }
        });
      this.subscriptions.add(this.receiveNotifictionsImagesProgress);
    }

    // this.options = {
    //   floor: 0,
    //   ceil: 2000000,
    //   translate: (value: number, label: LabelType): string => {
    //     switch (label) {
    //       case LabelType.Low:
    //         return `<b>Min :</b> ${value}€`;
    //       case LabelType.High:
    //         return `<b>Max :</b> ${value}€`;
    //       default:
    //         return "$" + value;
    //     }
    //   }
    // }
  }

  loadData() {
    this.propertiesService.canCreateProperties().subscribe((result) => {
      this.canActivateProperties = result;
    });

    this.propertyFilters.page = this.page;
    this.propertiesService
      .getAll(this.propertyFilters)
      .pipe(
        tap(() => (this.hideElement = true)),
        //delay(10000),
        tap((data) => {
          ((this.total = data.total), (this.totalPropertyFilters = this.total));
          this.totalExported = data.totalExported;
          if (this.maxPrice === 0) {
            this.maxPrice = data.maxPrice;
            this.options = {
              floor: 0,
              ceil: data.maxPrice,
              translate: (value: any, label: LabelType): string => {
                if (value) {
                  let price = value.toString().split(".");
                  const spaces = (price: any) =>
                    String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, " ");
                  const price1 = spaces(price[0]);
                  if (price.length > 1) return price1 + "," + price[1] + " €";

                  value = price1 + " €";
                }
                switch (label) {
                  case LabelType.Low:
                    return `<b>Min:</b> ${value}`;
                  case LabelType.High:
                    return `<b>Max:</b> ${value}`;
                  default:
                    return "$" + value;
                }
              },
            };
          }
        }),
        map((data) => data.properties),
        tap(() => this.paginate()),
        tap(() => (this.noresult = false)),
        finalize(() => {
          this.hideElement = false;
        }),
      )
      .subscribe((properties) => {
        if (this.propertyFilters?.exportId) {
          const totalExp = this.propertyFilters.isExported
            ? { totalexp: this.total, totalNotexp: this.totalExported }
            : { totalexp: this.totalExported, totalNotexp: this.total };
          this.eventService.broadcast("total-properties-export", totalExp);
        }

        this.properties = properties;

        if (this.total === 0) {
          this.noresult = true;
        }
        if (this.masterSelected) this.masterSelected = false;
        this.isLoadingList = false;

        const menuData = this.menuService.getData();

        if (menuData?.menu === "proposals") {
          if (menuData && menuData.propertyId) {
            if (menuData.id) {
              this.openProposal = menuData.id;
              let l: any = this.properties.find((property: any) => {
                return property.id === menuData.propertyId;
              });
              if (l) {
                setTimeout(() => {
                  this.openModal(l);
                }, 500);
              } else {
                this.propertiesService
                  .findPrevById(menuData.propertyId)
                  .subscribe((property) => {
                    if (property) {
                      setTimeout(() => {
                        this.openModal(property);
                      }, 500);
                    }
                  });
              }
            } else {
              this.errorMsg(this.translate.instant("t-proposal-no-available"));
            }
          }

          this.menuService.setData(null);
        } else if (menuData?.menu === "properties") {
          if (menuData && menuData.propertyId) {
            this.openDetails = menuData.propertyId;
            let p: any = this.properties.find((property: any) => {
              return property.id === menuData.propertyId;
            });
            if (p) {
              setTimeout(() => {
                this.openModal(p);
              }, 500);
            }
          }
        }
        if (menuData?.menu === "details") {
          if (menuData && menuData.propertyId) {
            if (menuData.id) {
              this.openDetails = menuData.id;

              let l: any = this.properties.find((property: any) => {
                return property.id === menuData.propertyId;
              });

              if (l) {
                setTimeout(() => {
                  this.openModal(l);
                }, 500);
              } else {
                this.propertiesService
                  .findPrevById(menuData.propertyId)
                  .subscribe((property) => {
                    if (property) {
                      setTimeout(() => {
                        this.openModal(property);
                      }, 500);
                    }
                  });
              }
            } else {
              this.errorMsg(this.translate.instant("t-property-no-available"));
            }
          }

          this.menuService.setData(null);
        }

        this.resetScroll();
      });
  }

  refreshProperties() {
    this.loadData();
    // this.isLoadingList = true;
  }

  countTotalPropertiesFilters() {
    // setTimeout(() => {
    this.propertyFilters.page = this.page;
    this.filtersProperties(true);
    this.isCountPropertyFilters = true;
    this.propertiesService
      .totalPropertiesFilters(this.propertyFilters)
      // .pipe(debounceTime(1000))
      .subscribe((data) => {
        this.isCountPropertyFilters = false;
        this.totalPropertyFilters = data.total;
      });
    // });
  }

  searchData() {
    this.propertyFilters.page = this.page;
    this.queryField.valueChanges
      .pipe(
        map((value) => value.trim()),
        //filter(value => value.length > 1),
        debounceTime(200),
        distinctUntilChanged(),
        tap((value) => {
          this.propertyFilters.search = value;
          // Nova pesquisa recomeça sempre na primeira página.
          this.page = 1;
          this.propertyFilters.page = this.page;
        }),
        switchMap((value) =>
          this.propertiesService.getAll(this.propertyFilters),
        ),
        tap((data) => (this.total = data.total)),
        map((data) => data.properties),
        tap(() => this.paginate()),
        tap(() => (this.noresult = false)),
      )
      .subscribe((users) => this.applySearchResult(users));

    this.referenceQueryField.valueChanges
      .pipe(
        map((value) => `${value ?? ""}`.trim()),
        debounceTime(200),
        distinctUntilChanged(),
        tap((value) => {
          this.propertyFilters.referenceSearch = value || undefined;
          this.page = 1;
          this.propertyFilters.page = this.page;
        }),
        switchMap(() => this.propertiesService.getAll(this.propertyFilters)),
        tap((data) => (this.total = data.total)),
        map((data) => data.properties),
        tap(() => this.paginate()),
        tap(() => (this.noresult = false)),
      )
      .subscribe((users) => this.applySearchResult(users));
  }

  private applySearchResult(users: any) {
    if (this.propertyFilters?.exportId) {
      const totalExp = this.propertyFilters.isExported
        ? { totalexp: this.total, totalNotexp: this.totalExported }
        : { totalexp: this.totalExported, totalNotexp: this.total };
      this.eventService.broadcast("total-properties-export", totalExp);
    }
    this.properties = users;
    if (this.total === 0) {
      this.noresult = true;
    }
    if (this.masterSelected) this.masterSelected = false;
    this.resetScroll();
  }

  /**
   * Form Validation
   */
  initFormPropertiesFilters() {
    // Inicializa locations a partir dos dados recebidos
    if ((!this.locations || this.locations.length === 0) && this.districts) {
      this.locations = this.districts;
    }
    const data: any = {};

    if (
      this.loginUser.role?.name === "AGENT" ||
      this.loginUser.role?.name === "COMMERCIAL DIRECTOR" ||
      this.loginUser.role?.name === "STORE OPERATOR"
    )
      data["showNetworkProperties"] = false;

    data["showStoreProperties"] = false;
    data["showMyProperties"] = false;
    data["stores"] = this.lockedStores.length ? [...this.lockedStores] : null;
    data["propertyTypes"] = null;
    data["minUsefulArea"] = null;
    data["maxUsefulArea"] = null;
    data["minYearofconstruction"] = null;
    data["maxYearofconstruction"] = null;
    data["minCreatedAt"] = null;
    data["maxCreatedAt"] = null;
    data["minUpdatedAt"] = null;
    data["maxUpdatedAt"] = null;
    data["minValidatedAt"] = null;
    data["maxValidatedAt"] = null;
    data["minPrice"] = this.minPrice;
    data["maxPrice"] = this.maxPrice;
    data["agents"] = null;
    data[`listingAgent`] = false;
    data[`secondaryAgent`] = false;
    data["websiteStatus"] = false;
    data["websiteHighlight"] = false;

    for (const condition of this.conditions) {
      data[`condition_${condition.id}`] = false;
    }
    for (const bStatus of this.businessStatus) {
      data[`businessStatus_${bStatus.id}`] = false;
    }

    for (const bTypes of this.businessTypes) {
      data[`businessTypes_${bTypes.id}`] = false;
    }

    for (const ec of this.ecs) {
      data[`ec_${ec.id}`] = false;
    }

    data["district"] = null;
    data["county"] = null;
    data["parish"] = null;
    data["typology"] = null;
    data["exclusive"] = false;
    this.propertiesFiltersForm = this.formBuilder.group(data);

    // Filtro de localização: distritos, concelhos, freguesias
    // Supondo que data.details?.locations está disponível como this.locations
    // Inicializa distritos
    if (this.locations) {
      this.districts = this.locations.map((d: any) => ({
        id: d.id,
        name: d.name,
        counties: d.counties,
      }));
    }

    // Atualiza concelhos ao selecionar distrito
    this.propertiesFiltersForm
      .get("district")
      ?.valueChanges.subscribe((districtIds: any) => {
        this.counties = [];
        this.parish = [];
        if (districtIds && districtIds.length > 0) {
          const selectedDistricts = this.districts.filter((d: any) =>
            districtIds.includes(d.id),
          );
          selectedDistricts.forEach((d: any) => {
            this.counties.push(
              ...d.counties.map((c: any) => ({
                id: c.id,
                name: c.name,
                parishs: c.parishs,
              })),
            );
          });
        }
        this.propertiesFiltersForm.patchValue({ county: null, parish: null });
      });

    // Atualiza freguesias ao selecionar concelho
    this.propertiesFiltersForm
      .get("county")
      ?.valueChanges.subscribe((countyIds: any) => {
        this.parish = [];
        if (countyIds && countyIds.length > 0) {
          const selectedCounties = this.counties.filter((c: any) =>
            countyIds.includes(c.id),
          );
          selectedCounties.forEach((c: any) => {
            this.parish.push(
              ...c.parishs.map((p: any) => ({ id: p.id, name: p.name })),
            );
          });
        }
        this.propertiesFiltersForm.patchValue({ parish: null });
      });

    this.propertiesFiltersForm.get(`stores`)?.valueChanges.subscribe((data) => {
      this.agents = [];

      this.propertiesFiltersForm.get(`agents`)?.patchValue([]);

      if (
        Array.isArray(this.propertiesFiltersForm.get(`stores`)?.value) &&
        this.propertiesFiltersForm.get(`stores`)?.value.length > 0
      ) {
        this.agents = this.agentsAux.filter((ag: any) => {
          return ag?.usersStores?.find((st: any) =>
            this.propertiesFiltersForm
              .get(`stores`)
              ?.value.includes(st?.storeId),
          );
        });
      } else {
        this.agents = this.agentsAux;
      }
    });

    this.propertiesFiltersForm
      .get("showNetworkProperties")
      ?.valueChanges.subscribe((data) => {
        this.getStores(this.loginUser.role?.name, data);
      });

    this.propertiesFiltersForm.valueChanges.subscribe((data) => {
      this.countFilters$.next(0);

      Object.entries(data).forEach(([key, val]: any) => {
        if (val === true) {
          let count = this.countFilters$.getValue();
          count++;
          this.countFilters$.next(count);
        }
        if (Array.isArray(val)) {
          let count = this.countFilters$.getValue();
          count += val.length;
          this.countFilters$.next(count);
        }
      });

      if (
        this.propertiesFiltersForm.get(`minPrice`)?.value !== this.minPrice ||
        this.propertiesFiltersForm.get(`maxPrice`)?.value !== this.maxPrice
      ) {
        let count = this.countFilters$.getValue();
        count++;
        this.countFilters$.next(count);
      }
      if (
        this.propertiesFiltersForm.get(`minUsefulArea`)?.value !== null ||
        this.propertiesFiltersForm.get(`maxUsefulArea`)?.value !== null
      ) {
        let count = this.countFilters$.getValue();
        count++;
        if (
          this.propertiesFiltersForm.get(`minUsefulArea`)?.value &&
          this.propertiesFiltersForm.get(`maxUsefulArea`)?.value === null
        ) {
          this.countFilters$.next(count);
        } else if (
          this.propertiesFiltersForm.get(`maxUsefulArea`)?.value > 0 &&
          this.propertiesFiltersForm.get(`minUsefulArea`)?.value === null
        ) {
          this.countFilters$.next(count);
        } else {
          this.countFilters$.next(count);
        }
        if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value === 0) {
          this.propertiesFiltersForm.patchValue({ minUsefulArea: null });
        }
        if (this.propertiesFiltersForm.get(`maxUsefulArea`)?.value === 0) {
          this.propertiesFiltersForm.patchValue({ maxUsefulArea: null });
        }
      }

      if (
        this.propertiesFiltersForm.get(`minYearofconstruction`)?.value !==
          null ||
        this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value !== null
      ) {
        let count = this.countFilters$.getValue();
        count++;

        if (
          this.propertiesFiltersForm.get(`minYearofconstruction`)?.value &&
          this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value ===
            null
        ) {
          this.countFilters$.next(count);
        } else if (
          this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value > 0 &&
          this.propertiesFiltersForm.get(`minYearofconstruction`)?.value ===
            null
        ) {
          this.countFilters$.next(count);
        } else {
          this.countFilters$.next(count);
        }
        if (
          this.propertiesFiltersForm.get(`minYearofconstruction`)?.value === 0
        ) {
          this.propertiesFiltersForm.patchValue({
            minYearofconstruction: null,
          });
        }
        if (
          this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value === 0
        ) {
          this.propertiesFiltersForm.patchValue({
            maxYearofconstruction: null,
          });
        }
      }

      if (
        this.propertiesFiltersForm.get(`minCreatedAt`)?.value ||
        this.propertiesFiltersForm.get(`maxCreatedAt`)?.value
      ) {
        this.countFilters$.next(this.countFilters$.getValue() + 1);
      }

      if (
        this.propertiesFiltersForm.get(`minUpdatedAt`)?.value ||
        this.propertiesFiltersForm.get(`maxUpdatedAt`)?.value
      ) {
        this.countFilters$.next(this.countFilters$.getValue() + 1);
      }

      if (
        this.propertiesFiltersForm.get(`minValidatedAt`)?.value ||
        this.propertiesFiltersForm.get(`maxValidatedAt`)?.value
      ) {
        this.countFilters$.next(this.countFilters$.getValue() + 1);
      }

      this.updateQuickFilterState();
    });

    this.countFilters$
      .asObservable()
      .pipe(debounceTime(100))
      .subscribe((count) => {
        this.countFiltersconditions = 0;
        this.countFiltersBusinessStatus = 0;
        this.countFiltersBusinessTypes = 0;
        this.countFiltersECS = 0;
        for (const condition of this.conditions) {
          if (
            this.propertiesFiltersForm.get(`condition_${condition.id}`)
              ?.value === true
          ) {
            this.countFiltersconditions++;
          }
        }

        for (const bStatus of this.businessStatus) {
          if (
            this.propertiesFiltersForm.get(`businessStatus_${bStatus.id}`)
              ?.value === true
          ) {
            this.countFiltersBusinessStatus++;
          }
        }

        for (const bTypes of this.businessTypes) {
          if (
            this.propertiesFiltersForm.get(`businessTypes_${bTypes.id}`)
              ?.value === true
          ) {
            this.countFiltersBusinessTypes++;
          }
        }

        for (const ec of this.ecs) {
          if (this.propertiesFiltersForm.get(`ec_${ec.id}`)?.value === true) {
            this.countFiltersECS++;
          }
        }

        if (count > 0 && !this.isCountPropertyFilters && !this.isOpenModal) {
          this.countTotalPropertiesFilters();
        } else if (
          count === 0 &&
          !this.isCountPropertyFilters &&
          !this.isOpenModal
        ) {
          this.countTotalPropertiesFilters();
        }
      });

    this.updateQuickFilterState();
  }

  touch(evt: any) {
    if (
      this.propertiesFiltersForm.get(`minUsefulArea`)?.value >
        this.propertiesFiltersForm.get(`maxUsefulArea`)?.value &&
      this.propertiesFiltersForm.get(`maxUsefulArea`)?.value > 0 &&
      this.propertiesFiltersForm.get(`minUsefulArea`)?.value > 0
    ) {
      this.propertiesFiltersForm.patchValue({
        maxUsefulArea: this.propertiesFiltersForm.get(`minUsefulArea`)?.value,
      });
    }
    if (this.propertiesFiltersForm.get(`minUsefulArea`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ minUsefulArea: null });
    }
    if (this.propertiesFiltersForm.get(`maxUsefulArea`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ maxUsefulArea: null });
    }

    if (
      this.propertiesFiltersForm.get(`minYearofconstruction`)?.value >
        this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value &&
      this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value > 0 &&
      this.propertiesFiltersForm.get(`minYearofconstruction`)?.value > 0
    ) {
      this.propertiesFiltersForm.patchValue({
        maxYearofconstruction: this.propertiesFiltersForm.get(
          `minYearofconstruction`,
        )?.value,
      });
    }
    if (this.propertiesFiltersForm.get(`minYearofconstruction`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ minYearofconstruction: null });
    }
    if (this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value === 0) {
      this.propertiesFiltersForm.patchValue({ maxYearofconstruction: null });
    }
  }

  loadCss() {
    // const dynamicCss = [
    //   { file: "", id: '' },
    // ];
    // for (let i = 0; i < dynamicCss.length; i++) {
    //   const cssLoad: any = document.querySelector(`#${dynamicCss[i].id}`);
    //   if (!cssLoad) {
    //     const node = document.createElement('link');
    //     node.rel = "stylesheet";
    //     node.href = dynamicCss[i].file;
    //     node.id = dynamicCss[i].id;
    //     document.getElementsByTagName('head')[0].appendChild(node);
    //   }
    // }
  }

  loadJs() {
    // const scriptLoad: any = document.querySelector("#bs-js");
    // if (!scriptLoad) {
    const dynamicScripts = [
      { file: "assets/libs/bootstrap/js/bootstrap.bundle.min.js", id: "bs-js" },
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const scriptLoad: any = document.querySelector(
        `#${dynamicScripts[i].id}`,
      );
      if (!scriptLoad) {
        const node = document.createElement("script");
        node.src = dynamicScripts[i].file;
        node.type = "text/javascript";
        node.async = true;
        node.id = dynamicScripts[i].id;
        document.body.appendChild(node);
      }
    }
    // }
  }

  openModal(propertyUpdate: any = null) {
    this.tabAgents(propertyUpdate);

    // this.isOpenModal = true;
    // this.property = propertyUpdate;
    // this.eventService.broadcast('modal-create-edit-property', propertyUpdate);
  }

  openModalDevelopments(propertyUpdate: any) {
    this.nabTabActive = 2;
    this.propertyToUpdate = propertyUpdate;
  }

  paginate() {
    this.startIndex = (this.page - 1) * this.pageSize + 1;
    this.endIndex = (this.page - 1) * this.pageSize + this.pageSize;
    if (this.endIndex > this.total) {
      this.endIndex = this.total;
    }
  }
  /**
   * Confirmation delete property
   */
  confirm(id: any) {
    Swal.fire({
      title: this.translate.instant(
        "t-m-properties.t-are-you-sure-you-want-to-delete-the-property",
      ),
      //text: 'Deleting your property will remove all of your information from our database.',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f46a6a",
      confirmButtonText: this.translate.instant("t-yes"),
      cancelButtonText: this.translate.instant("t-close"),
    }).then((result) => {
      if (result.value) {
        this.propertiesService.delete(id).subscribe(
          (property) => {
            this.refreshProperties();
            Swal.fire(
              this.translate.instant("t-m-properties.t-deleted"),
              this.translate.instant(
                "t-m-properties.t-the-property-was-successfully-deleted",
              ),
              "success",
            );
          },
          (error) => {
            // console.error(error);
            this.errorMsg(
              this.translate.instant("t-m-properties.t-error-property-deleted"),
            );
          },
          () => {
            console.log("complete delete property");
          },
        );
      }
    });
  }

  duplicateProperty(property: any) {
    if (!property?.id || property?.isDuplicating) return;

    const isAutoReference = !!this.dataToFormInitDetails?.checkAutoRef;
    const swalOptions: any = {
      title: this.translate.instant("t-duplicate-property"),
      text: this.translate.instant("t-duplicate-property-question"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: this.translate.instant("t-duplicate"),
      cancelButtonText: this.translate.instant("t-cancel"),
    };

    if (!isAutoReference) {
      swalOptions.input = "text";
      swalOptions.inputLabel = this.translate.instant(
        "t-m-properties.t-reference",
      );
      swalOptions.inputValidator = (value: string) => {
        if (!value?.trim()) {
          return this.translate.instant("t-reference-error-required");
        }

        return null;
      };
    }

    Swal.fire(swalOptions).then((result) => {
      if (!result.value) return;

      const reference = isAutoReference
        ? undefined
        : `${result.value}`.trim();

      property.isDuplicating = true;
      this.propertiesService
        .duplicateProperty(property.id, reference)
        .pipe(finalize(() => (property.isDuplicating = false)))
        .subscribe({
          next: (data) => {
            this.refreshProperties();
            if (data?.resId)
              this.eventService.broadcast("new-property-created", data.resId);
            Swal.fire(
              this.translate.instant("t-property-duplicated"),
              this.translate.instant("t-property-duplicated-successfully"),
              "success",
            );
          },
          error: (error) => {
            const message = error?.error?.message;
            this.errorMsg(
              message === "Reference already exists"
                ? this.translate.instant(
                    "t-m-properties.t-this-reference-has-already-been-used",
                  )
                : this.translate.instant("t-property-duplicate-error"),
            );
          },
        });
    });
  }

  deleteMultiple() {
    if (this.checkedList?.length > 0) {
      Swal.fire({
        title: this.translate.instant(
          "t-m-properties.t-are-you-sure-you-want-to-delete-the-property",
        ),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        confirmButtonText: this.translate.instant("t-yes"),
        cancelButtonText: this.translate.instant("t-cancel"),
      }).then((result) => {
        if (result.value) {
          this.propertiesService.deleteByIds(this.checkedList).subscribe(
            () => {
              this.refreshProperties();
              Swal.fire(
                this.translate.instant("t-m-properties.t-deleted"),
                this.translate.instant(
                  "t-m-properties.t-properties-have-been-successfully-deleted",
                ),
                "success",
              );
            },
            (error) => {
              // console.error(error);
              this.errorMsg(
                this.translate.instant(
                  "t-m-properties.t-at-the-moment-it-is-not-possible-to-delete-the-property",
                ),
              );
            },
            () => {
              this.countCheckSelected = 0;
              console.log("complete delete properties");
            },
          );
        }
      });
    }
  }

  checkUncheckAll(master: boolean) {
    if (master) {
      for (let i = 0; i < this.properties.length; i++) {
        if (!this.properties[i].isProcessing)
          this.properties[i].isSelected = this.masterSelected;
      }
    } else {
      this.masterSelected = false;
    }
    this.getCheckedItemList();
  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.countCheckSelected = 0;
    this.checkedList = [];
    for (var i = 0; i < this.properties.length; i++) {
      if (this.properties[i].isSelected) {
        this.checkedList.push(this.properties[i].id);
        this.countCheckSelected++;
      }
    }
    if (this.countCheckSelected == this.pageSize) this.masterSelected = true;
  }

  createDateFormat(date: any) {
    const d = new Date(date);
    return d.toLocaleString();
  }

  isDateAvailable(date: any) {
    return new Date(date) > new Date();
  }

  /**
   * Title sweet alert
   * @param errorMsg Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: "Oops...! Something went Wrong !",
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: "Close",
    });
  }

  priceFormat(propertyPrice: any, symbol: string = "€") {
    if (propertyPrice) {
      let price = propertyPrice.toString().split(".");
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, " ");
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + "," + price[1] + " " + symbol;

      return price1 + " " + symbol;
    }
    return propertyPrice;
  }

  tabAll() {
    this.propertiesService.getDataForAllTab().subscribe((data) => {
      this.allData = data;
      this.dataToFormInitDetails = data.details;
      this.dataToFormInitAddress = data.countries;
      this.dataToFormInitAreasNearby = data.divisionsNearby;
      this.dataToFormInitChar = data.characteristics;
      this.dataToFormInitAdvertisement = data.advertisement;
      this.dataToFormInitAgents = data.agents;
      this.dataToFormInitPortals = { portals: data.portals };
      this.requiredOwner = data?.details?.commissions?.requiredOwner;

      this.propertyTypes = data.details?.propertyTypes?.filter(
        (pt: any) => pt.description !== "---",
      );
      this.propertyTypeGroups = this.buildPropertyTypeGroups(this.propertyTypes);

      this.stores = data.details?.stores;
      this.storesAux = data.details?.stores;
      this.districts = data.details?.locations;
      this.districtsAux = data.details?.locations;

      this.conditions = data.details?.conditions?.filter(
        (pt: any) => pt.description !== "---",
      );

      this.businessStatus = data.details?.businessStatus?.filter(
        (bt: any) => bt.description !== "---",
      );

      this.filtersBusinessStatus = data.details?.businessStatus?.filter(
        (bt: any) => bt.description !== "---",
      );
      this.statusList = this.businessStatus;

      this.ecs = data.details?.ec?.filter((e: any) => e.description !== "---");

      this.businessTypes = data.details?.businessTypes?.filter(
        (bt: any) => bt.description !== "---",
      );

      this.prospectingId = data?.details?.prospecting;

      // this.conditions = data.details?.contdi?.filter((pt: any) => pt.description !== '---');
      this.agentsAux = data.agents;
      this.agents = data.agents;
      const act = this.dataToFormInitAdvertisement.options.find(
        (op: any) => op.order === 0,
      );

      const menuData = this.menuService.getData();
      this.openModaltSubject$.next(5);
      this.initFormPropertiesFilters();
      this.applyDefaultBusinessStatusFilter();
      this.filtersProperties(true);
      this.refreshProperties();

      if (this.openCreateProperty === true) {
        this.openModal();
        this.applyOwnerFromDealListingMenu(menuData);
      }

      if (this.openPreview !== null) {
        this.getPropertyToPreview(this.openPreview);
      }

      this.tryAutoOpenPropertyFromQuery();
    });
  }

  private setPendingAutoOpenPropertyFromQuery() {
    const openPropertyIdParam = this.route.snapshot.queryParamMap.get("openPropertyId");
    if (!openPropertyIdParam) {
      return;
    }

    const parsedId = Number(openPropertyIdParam);
    if (Number.isFinite(parsedId) && parsedId > 0) {
      this.pendingAutoOpenPropertyId = parsedId;
      return;
    }

    // Também aceita o uuid do imóvel, usado nos links abertos em nova aba
    const uuid = openPropertyIdParam.trim();
    if (uuid) {
      this.pendingAutoOpenPropertyId = uuid;
    }
  }

  private tryAutoOpenPropertyFromQuery() {
    if (this.autoOpenPropertyProcessed || !this.pendingAutoOpenPropertyId) {
      return;
    }

    const propertyId = this.pendingAutoOpenPropertyId;
    this.autoOpenPropertyProcessed = true;

    const propertyFromList = this.properties?.find((property: any) =>
      typeof propertyId === "number"
        ? Number(property?.id) === Number(propertyId)
        : `${property?.id}` === `${propertyId}`,
    );

    if (propertyFromList) {
      this.openModal(propertyFromList);
      return;
    }

    this.propertiesService
      .findPrevById(propertyId)
      .pipe(take(1))
      .subscribe({
        next: (property: any) => {
          if (property) {
            this.openModal(property);
          }
        },
        error: () => {
          this.autoOpenPropertyProcessed = false;
        },
      });
  }

  onChildValueChange(event: any) {
    this.propertyToUpdate = null;
  }

  tabAgents(property: any) {
    this.property = property;

    if (property) {
      let storeMain = this.dataToFormInitDetails?.stores.find(
        (s: any) => s.isMain === true,
      );
      // if (property) {
      storeMain = property.store;
      // }
      let val: number = this.openModaltSubject$.value;

      if (storeMain?.id /*&& val === 5*/) {
        this.propertiesService
          .getDataForAgents(storeMain.id, "", true)
          .subscribe((data: any) => {
            this.dataToFormInitAgents = data;

            setTimeout(() => {
              this.isOpenModal = true;
              this.openModaltSubject$.next(6);
            });
          });
      }
    } else {
      setTimeout(() => {
        this.isOpenModal = true;
        this.openModaltSubject$.next(6);
      });
    }
  }

  private applyOwnerFromDealListingMenu(menuData: any) {
    if (
      !menuData ||
      menuData?.menu !== "create-property-from-deal-listing" ||
      !menuData?.ownerContact?.id
    ) {
      return;
    }

    setTimeout(() => {
      this.eventService.broadcast("add-exist-contact", {
        kind: "owners",
        contacts: [menuData.ownerContact],
      });
      this.menuService.setData(null);
    }, 900);
  }

  changePrice(event: any, isMin = true) {
    if (isMin) {
      this.propertiesFiltersForm.patchValue({ minPrice: event });
    } else {
      this.propertiesFiltersForm.patchValue({ maxPrice: event });
    }
  }

  onChangestatus(event: any) {
    this.clearAppliedSavedFilter();
    const statusId = typeof event === "object" ? event?.id : event;
    this.selectedStatusId = statusId ?? null;
    this.patchBusinessStatusSelection(statusId);
    this.filtersProperties(true);
    this.updateQuickFilterState();
    this.refreshProperties();
  }

  changeHideUnits(event: Event) {
    this.clearAppliedSavedFilter();
    if (event)
      this.propertyFilters.hideUnits = (
        event.target as HTMLInputElement
      ).checked;

    this.updateQuickFilterState();
    this.refreshProperties();
  }

  changeMinCommissionPending(event: Event) {
    this.clearAppliedSavedFilter();
    if (event)
      this.propertyFilters.minimumCommissionPendingValidation = (
        event.target as HTMLInputElement
      ).checked;

    this.updateQuickFilterState();
    this.refreshProperties();
  }

  changeOutdatedParish(event: Event) {
    this.clearAppliedSavedFilter();
    if (event)
      this.propertyFilters.outdatedParish = (
        event.target as HTMLInputElement
      ).checked;

    this.updateQuickFilterState();
    this.refreshProperties();
  }

  applySavedPropertyFilter(event: PropertySavedFilterApplyEvent) {
    this.appliedSavedFilterId = event?.filter?.id || null;
    this.appliedSavedFilterName = event?.filter?.name || null;
    const payload = event?.payload || ({ version: 1, filters: {} } as any);
    const filters = this.cloneSavedFilterData(
      payload.filters || {},
    ) as Partial<PropertyFiltersModel>;

    this.page = 1;
    this.propertyFilters = {
      ...filters,
      page: this.page,
    };

    if (this.portalExportError?.id && this.portalExportError?.status) {
      this.propertyFilters.exportId = this.portalExportError.id;
      this.propertyFilters.isExported = this.portalExportError.isExported;
    }

    this.selectedStatusId =
      payload.ui?.selectedStatusId ?? this.resolveStatusIdFromFilters(filters);
    this.selectedScope =
      payload.ui?.selectedScope !== undefined
        ? payload.ui.selectedScope
        : this.selectedScope;
    this.sortColumn = (filters["sortColumn"] as any) || null;
    this.sortDirection = filters["sortDirection"] || "asc";
    this.queryField.patchValue(filters["search"] || "", { emitEvent: false });
    this.referenceQueryField.patchValue(filters["referenceSearch"] || "", {
      emitEvent: false,
    });
    this.applySavedPropertyFilterForm(payload.formValue);
    // Um filtro guardado noutra agência não sai do contexto do topbar.
    this.applyAgencyStoreLock();
    this.updateQuickFilterState();
    this.loadData();
  }

  applyQuickFilters() {
    this.clearAppliedSavedFilter();
    this.filtersProperties(true);
    this.updateQuickFilterState();
    this.refreshProperties();
  }

  clearAppliedSavedFilter() {
    this.appliedSavedFilterId = null;
    this.appliedSavedFilterName = null;
  }

  private buildActiveFilterChips() {
    const chips: any[] = [];

    if (this.appliedSavedFilterName) {
      chips.push({
        key: "saved",
        label: `${this.translate.instant("t-saved-filters.t-button")}: ${this.appliedSavedFilterName}`,
        icon: "ri-bookmark-3-line",
      });
    }

    if (this.hasStatusFilter) {
      chips.push({
        key: "status",
        label: `${this.translate.instant("t-m-properties.t-status")}: ${this.getStatusFilterLabel()}`,
        icon: "ri-checkbox-circle-line",
      });
    }

    if (this.propertyFilters?.hideUnits === true) {
      chips.push({
        key: "hideUnits",
        label: this.translate.instant("t-developments.t-hide-units"),
        icon: "ri-eye-off-line",
      });
    }

    if (this.propertyFilters?.minimumCommissionPendingValidation === true) {
      chips.push({
        key: "minimumCommissionPendingValidation",
        label: this.translate.instant("t-developments.t-commission-to-validate"),
        icon: "ri-percent-line",
      });
    }

    if (this.propertyFilters?.outdatedParish === true) {
      chips.push({
        key: "outdatedParish",
        label: this.translate.instant(
          "t-property-quick-filters.t-outdated-parishes",
        ),
        icon: "ri-map-pin-time-line",
      });
    }

    const locationLabel = this.getLocationFilterLabel();
    if (locationLabel) {
      chips.push({
        key: "location",
        label: `${this.translate.instant("t-m-properties.t-location")}: ${locationLabel}`,
        icon: "ri-map-pin-line",
      });
    }

    const typologyLabel = this.getSelectedNames(
      this.typologies,
      this.propertiesFiltersForm?.get("typology")?.value,
    );
    if (typologyLabel) {
      chips.push({
        key: "typology",
        label: `${this.translate.instant("t-typology")}: ${typologyLabel}`,
        icon: "ri-layout-grid-line",
      });
    }

    const propertyTypeLabel = this.getSelectedNames(
      this.propertyTypes,
      this.propertiesFiltersForm?.get("propertyTypes")?.value,
      "description",
    );
    if (propertyTypeLabel) {
      chips.push({
        key: "propertyTypes",
        label: `${this.translate.instant("t-m-properties.t-property-type")}: ${propertyTypeLabel}`,
        icon: "ri-home-4-line",
      });
    }

    const advancedChips = this.buildAdvancedFilterChips();
    chips.push(...advancedChips);

    const advancedCount = Math.max(
      0,
      (this.countFilters$?.getValue?.() || 0) - this.getVisibleQuickFormCount(),
    );
    const advancedRemainder = Math.max(0, advancedCount - advancedChips.length);
    if (advancedRemainder > 0) {
      chips.push({
        key: "advanced",
        label: `${this.translate.instant("t-property-quick-filters.t-advanced")}: ${advancedRemainder}`,
        icon: "ri-filter-3-line",
      });
    }

    return chips;
  }

  private updateQuickFilterState() {
    const selectedBusinessStatusIds = this.getSelectedBusinessStatusIds();
    this.selectedStatusId =
      selectedBusinessStatusIds.length === 1 ? selectedBusinessStatusIds[0] : null;
    this.hasStatusFilter = selectedBusinessStatusIds.length > 0;
    this.statusFilterLabel = this.getStatusFilterLabel();
    this.locationFilterLabel = this.getLocationFilterLabel();
    this.typologyFilterLabel = this.getSelectedNames(
      this.typologies,
      this.propertiesFiltersForm?.get("typology")?.value,
    );
    this.propertyTypeFilterLabel = this.getSelectedNames(
      this.propertyTypes,
      this.propertiesFiltersForm?.get("propertyTypes")?.value,
      "description",
    );
    this.currentSavedFilterFormValue =
      this.propertiesFiltersForm?.getRawValue?.() ||
      this.propertiesFiltersForm?.value ||
      null;
    this.activeFilterChips = this.buildActiveFilterChips();
  }

  removeActiveFilter(chip: any) {
    if (!chip?.key) return;

    if (chip.key === "saved") {
      this.clearAppliedSavedFilter();
      this.updateQuickFilterState();
      return;
    }

    if (chip.key === "status") {
      this.clearAppliedSavedFilter();
      this.selectedStatusId = null;
      this.patchBusinessStatusSelection(null);
      this.filtersProperties(true);
      this.updateQuickFilterState();
      this.refreshProperties();
      return;
    }

    if (chip.key === "hideUnits") {
      this.clearAppliedSavedFilter();
      this.propertyFilters.hideUnits = false;
      this.updateQuickFilterState();
      this.refreshProperties();
      return;
    }

    if (chip.key === "minimumCommissionPendingValidation") {
      this.clearAppliedSavedFilter();
      this.propertyFilters.minimumCommissionPendingValidation = false;
      this.updateQuickFilterState();
      this.refreshProperties();
      return;
    }

    if (chip.key === "outdatedParish") {
      this.clearAppliedSavedFilter();
      this.propertyFilters.outdatedParish = false;
      this.updateQuickFilterState();
      this.refreshProperties();
      return;
    }

    if (chip.key === "location") {
      this.propertiesFiltersForm.patchValue({
        district: null,
        county: null,
        parish: null,
      });
      this.applyQuickFilters();
      return;
    }

    if (chip.key === "typology") {
      this.propertiesFiltersForm.patchValue({ typology: null });
      this.applyQuickFilters();
      return;
    }

    if (chip.key === "propertyTypes") {
      this.propertiesFiltersForm.patchValue({ propertyTypes: null });
      this.applyQuickFilters();
      return;
    }

    if (chip.remove) {
      this.removeAdvancedFilterChip(chip);
      return;
    }

    if (chip.key === "advanced") {
      this.resetPropertiesFiltersForm();
      this.applyQuickFilters();
    }
  }

  clearAllActiveFilters() {
    this.clearAppliedSavedFilter();
    this.selectedStatusId = null;
    this.propertyFilters.hideUnits = false;
    this.propertyFilters.minimumCommissionPendingValidation = false;
    this.propertyFilters.outdatedParish = false;
    this.resetPropertiesFiltersForm();
    this.filtersProperties(true);
    this.updateQuickFilterState();
    this.refreshProperties();
  }

  getStatusFilterLabel() {
    const selectedIds = this.getSelectedBusinessStatusIds();
    return (
      this.getSelectedNames(this.statusList, selectedIds, "description") ||
      this.translate.instant("t-m-properties.t-status")
    );
  }

  getLocationFilterLabel() {
    const parishLabel = this.getSelectedNames(
      this.parish,
      this.propertiesFiltersForm?.get("parish")?.value,
    );
    if (parishLabel) return parishLabel;

    const countyLabel = this.getSelectedNames(
      this.counties,
      this.propertiesFiltersForm?.get("county")?.value,
    );
    if (countyLabel) return countyLabel;

    return this.getSelectedNames(
      this.districts,
      this.propertiesFiltersForm?.get("district")?.value,
    );
  }

  getSelectedNames(items: any[], selectedIds: any, labelKey = "name") {
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) return "";

    const names = (items || [])
      .filter((item: any) => this.includesQuickFilterValue(selectedIds, item.id))
      .map((item: any) => item[labelKey] || item.name)
      .filter(Boolean);

    if (names.length <= 2) return names.join(", ");

    return `${names.slice(0, 2).join(", ")} +${names.length - 2}`;
  }

  private buildAdvancedFilterChips() {
    const chips: any[] = [];

    this.pushSelectedOptionChips(chips, {
      controlName: "stores",
      items: this.stores,
      label: this.translate.instant("t-m-properties.t-store"),
      icon: "ri-store-2-line",
    });
    this.pushSelectedOptionChips(chips, {
      controlName: "agents",
      items: this.agentsAux,
      label: this.translate.instant("t-m-properties.t-agents"),
      icon: "ri-user-star-line",
    });
    this.pushBooleanOptionChips(chips, {
      items: this.conditions,
      controlPrefix: "condition",
      label: this.translate.instant("t-m-properties.t-condition"),
      icon: "ri-home-gear-line",
      labelKey: "description",
    });
    this.pushBooleanOptionChips(chips, {
      items: this.businessTypes,
      controlPrefix: "businessTypes",
      label: this.translate.instant("t-m-properties.t-business-type"),
      icon: "ri-hand-coin-line",
      labelKey: "description",
    });
    this.pushBooleanOptionChips(chips, {
      items: this.ecs,
      controlPrefix: "ec",
      label: this.translate.instant("t-m-properties.t-energetic-certification"),
      icon: "ri-flashlight-line",
      labelKey: "description",
    });

    this.pushBooleanControlChip(chips, "listingAgent", this.translate.instant("t-properties-agents.t-listing-agent"), "ri-user-location-line");
    this.pushBooleanControlChip(chips, "secondaryAgent", this.translate.instant("t-properties-agents.t-secondary-agent"), "ri-user-shared-line");
    this.pushBooleanControlChip(chips, "exclusive", this.translate.instant("t-exclusives-only"), "ri-star-line");
    this.pushBooleanControlChip(chips, "websiteStatus", this.translate.instant("t-published-website"), "ri-global-line");
    this.pushBooleanControlChip(chips, "websiteHighlight", this.translate.instant("t-highlighted-website"), "ri-sparkling-line");

    this.pushRangeChip(chips, {
      key: "price",
      label: this.translate.instant("t-m-properties.t-price"),
      icon: "ri-money-euro-circle-line",
      minControl: "minPrice",
      maxControl: "maxPrice",
      isActive: () =>
        this.propertiesFiltersForm?.get("minPrice")?.value !== this.minPrice ||
        this.propertiesFiltersForm?.get("maxPrice")?.value !== this.maxPrice,
      reset: { minPrice: this.minPrice, maxPrice: this.maxPrice },
    });
    this.pushRangeChip(chips, {
      key: "usefulArea",
      label: this.translate.instant("t-m-properties.t-useful-area"),
      icon: "ri-ruler-line",
      minControl: "minUsefulArea",
      maxControl: "maxUsefulArea",
    });
    this.pushRangeChip(chips, {
      key: "yearofconstruction",
      label: this.translate.instant("t-m-properties.t-year-of-construction"),
      icon: "ri-calendar-line",
      minControl: "minYearofconstruction",
      maxControl: "maxYearofconstruction",
    });
    this.pushRangeChip(chips, {
      key: "createdAt",
      label: this.translate.instant("t-created-at"),
      icon: "ri-calendar-event-line",
      minControl: "minCreatedAt",
      maxControl: "maxCreatedAt",
      isDate: true,
    });
    this.pushRangeChip(chips, {
      key: "updatedAt",
      label: this.translate.instant("t-m-properties.t-updated-at"),
      icon: "ri-refresh-line",
      minControl: "minUpdatedAt",
      maxControl: "maxUpdatedAt",
      isDate: true,
    });
    this.pushRangeChip(chips, {
      key: "validatedAt",
      label: this.translate.instant("t-validated-at"),
      icon: "ri-shield-check-line",
      minControl: "minValidatedAt",
      maxControl: "maxValidatedAt",
      isDate: true,
    });

    return chips;
  }

  private pushSelectedOptionChips(
    chips: any[],
    config: {
      controlName: string;
      items: any[];
      label: string;
      icon: string;
      labelKey?: string;
    },
  ) {
    const selectedIds = this.propertiesFiltersForm?.get(config.controlName)?.value;
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) return;

    selectedIds.forEach((id: any) => {
      const item = (config.items || []).find((option: any) =>
        this.isSameQuickFilterValue(option?.id, id),
      );
      chips.push({
        key: `${config.controlName}:${id}`,
        label: `${config.label}: ${item?.[config.labelKey || "name"] || item?.description || id}`,
        icon: config.icon,
        remove: { kind: "arrayValue", controlName: config.controlName, id },
      });
    });
  }

  private pushBooleanOptionChips(
    chips: any[],
    config: {
      items: any[];
      controlPrefix: string;
      label: string;
      icon: string;
      labelKey?: string;
    },
  ) {
    (config.items || []).forEach((item: any) => {
      const controlName = `${config.controlPrefix}_${item.id}`;
      if (this.propertiesFiltersForm?.get(controlName)?.value === true) {
        chips.push({
          key: controlName,
          label: `${config.label}: ${item?.[config.labelKey || "name"] || item?.description || item?.name}`,
          icon: config.icon,
          remove: { kind: "booleanControl", controlName },
        });
      }
    });
  }

  private pushBooleanControlChip(
    chips: any[],
    controlName: string,
    label: string,
    icon: string,
  ) {
    if (this.propertiesFiltersForm?.get(controlName)?.value === true) {
      chips.push({
        key: controlName,
        label,
        icon,
        remove: { kind: "booleanControl", controlName },
      });
    }
  }

  private pushRangeChip(
    chips: any[],
    config: {
      key: string;
      label: string;
      icon: string;
      minControl: string;
      maxControl: string;
      reset?: Record<string, any>;
      isDate?: boolean;
      isActive?: () => boolean;
    },
  ) {
    const minValue = this.propertiesFiltersForm?.get(config.minControl)?.value;
    const maxValue = this.propertiesFiltersForm?.get(config.maxControl)?.value;
    const isActive = config.isActive
      ? config.isActive()
      : minValue !== null || maxValue !== null;

    if (!isActive) return;

    chips.push({
      key: config.key,
      label: `${config.label}: ${this.getRangeFilterLabel(minValue, maxValue, config.isDate)}`,
      icon: config.icon,
      remove: {
        kind: "controls",
        values:
          config.reset || {
            [config.minControl]: null,
            [config.maxControl]: null,
          },
      },
    });
  }

  private getRangeFilterLabel(minValue: any, maxValue: any, isDate = false) {
    const min = this.formatAdvancedFilterValue(minValue, isDate);
    const max = this.formatAdvancedFilterValue(maxValue, isDate);

    if (min && max) return `${min} - ${max}`;
    if (min) return `>= ${min}`;
    if (max) return `<= ${max}`;
    return this.translate.instant("t-property-quick-filters.t-active");
  }

  private formatAdvancedFilterValue(value: any, isDate = false) {
    if (value === null || value === undefined || value === "") return "";

    if (!isDate) return `${value}`;

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return `${value}`;

    const day = `${date.getDate()}`.padStart(2, "0");
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    return `${day}/${month}/${date.getFullYear()}`;
  }

  private removeAdvancedFilterChip(chip: any) {
    const remove = chip.remove;
    if (!remove) return;

    this.clearAppliedSavedFilter();

    if (remove.kind === "arrayValue") {
      const current = this.propertiesFiltersForm?.get(remove.controlName)?.value;
      const next = Array.isArray(current)
        ? current.filter((value: any) => !this.isSameQuickFilterValue(value, remove.id))
        : [];
      this.propertiesFiltersForm.patchValue({
        [remove.controlName]: next.length ? next : null,
      });
      this.applyQuickFilters();
      return;
    }

    if (remove.kind === "booleanControl") {
      this.propertiesFiltersForm.patchValue({ [remove.controlName]: false });
      this.applyQuickFilters();
      return;
    }

    if (remove.kind === "controls") {
      this.propertiesFiltersForm.patchValue(remove.values || {});
      this.applyQuickFilters();
    }
  }

  getPropertyTypeGroups(): Array<{ name: string; items: any[] }> {
    return this.propertyTypeGroups;
  }

  private buildPropertyTypeGroups(items: any[]): Array<{ name: string; items: any[] }> {
    const groups = (items || []).reduce(
      (acc: Record<string, any[]>, item: any) => {
        const name =
          item.groupDescription && item.groupDescription !== "---"
            ? item.groupDescription
            : "N/A";
        acc[name] = acc[name] || [];
        acc[name].push(item);
        return acc;
      },
      {},
    );

    return Object.entries(groups).map(([name, items]) => ({
      name,
      items: items as any[],
    }));
  }

  isQuickFormArrayValueSelected(controlName: string, id: any) {
    const value = this.propertiesFiltersForm?.get(controlName)?.value;
    return this.includesQuickFilterValue(value, id);
  }

  onQuickFormArrayValueClick(event: Event, controlName: string, id: any) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleQuickFormArrayValue(controlName, id);
  }

  onQuickPropertyTypeGroupClick(event: Event, group: any) {
    event.preventDefault();
    event.stopPropagation();
    this.togglePropertyTypeGroup(group);
  }

  toggleQuickFormArrayValue(controlName: string, id: any) {
    const control = this.propertiesFiltersForm?.get(controlName);
    if (!control) return;

    const current = Array.isArray(control.value) ? [...control.value] : [];
    const next = this.includesQuickFilterValue(current, id)
      ? current.filter((value) => !this.isSameQuickFilterValue(value, id))
      : [...current, id];

    control.patchValue(next.length ? next : null);
    this.applyQuickFilters();
  }

  isPropertyTypeGroupSelected(group: any) {
    const selected = this.propertiesFiltersForm?.get("propertyTypes")?.value;
    if (!Array.isArray(selected) || !group?.items?.length) return false;

    return group.items.every((item: any) =>
      this.includesQuickFilterValue(selected, item.id),
    );
  }

  getPropertyTypeGroupSelectedCount(group: any) {
    const selected = this.propertiesFiltersForm?.get("propertyTypes")?.value;
    if (!Array.isArray(selected) || !group?.items?.length) return 0;

    return group.items.filter((item: any) =>
      this.includesQuickFilterValue(selected, item.id),
    ).length;
  }

  togglePropertyTypeGroup(group: any) {
    const control = this.propertiesFiltersForm?.get("propertyTypes");
    if (!control || !group?.items?.length) return;

    const current = Array.isArray(control.value) ? [...control.value] : [];
    const groupIds = group.items.map((item: any) => item.id);
    const isSelected = groupIds.every((id: any) =>
      this.includesQuickFilterValue(current, id),
    );
    const next = isSelected
      ? current.filter(
          (id: any) =>
            !groupIds.some((groupId: any) =>
              this.isSameQuickFilterValue(groupId, id),
            ),
        )
      : Array.from(new Set([...current, ...groupIds]));

    control.patchValue(next.length ? next : null);
    this.applyQuickFilters();
  }

  private includesQuickFilterValue(values: any, id: any) {
    return (
      Array.isArray(values) &&
      values.some((value: any) => this.isSameQuickFilterValue(value, id))
    );
  }

  private isSameQuickFilterValue(a: any, b: any) {
    return String(a) === String(b);
  }

  private getVisibleQuickFormCount() {
    const countArray = (key: string) =>
      Array.isArray(this.propertiesFiltersForm?.get(key)?.value)
        ? this.propertiesFiltersForm.get(key)?.value.length
        : 0;

    return (
      countArray("district") +
      countArray("county") +
      countArray("parish") +
      countArray("typology") +
      countArray("propertyTypes") +
      this.getSelectedBusinessStatusIds().length
    );
  }

  private applySavedPropertyFilterForm(formValue?: Record<string, any>) {
    if (!this.propertiesFiltersForm || !formValue) return;

    const data = this.cloneSavedFilterData(formValue);
    const county = data["county"] || null;
    const parish = data["parish"] || null;

    this.resetPropertiesFiltersForm();
    this.syncSavedFilterLocations(data["district"], county);
    this.propertiesFiltersForm.patchValue(
      {
        ...data,
        county: null,
        parish: null,
      },
      { emitEvent: true },
    );
    this.syncSavedFilterLocations(data["district"], county);

    setTimeout(() => {
      this.propertiesFiltersForm.patchValue(
        {
          county,
          parish,
        },
        { emitEvent: true },
      );
      this.updateQuickFilterState();
    });
  }

  private syncSavedFilterLocations(
    districtIds: any[] = [],
    countyIds: any[] = [],
  ) {
    this.counties = [];
    this.parish = [];

    if (Array.isArray(districtIds) && districtIds.length > 0) {
      const selectedDistricts = this.districts.filter((district: any) =>
        districtIds.includes(district.id),
      );
      selectedDistricts.forEach((district: any) => {
        this.counties.push(
          ...(district.counties || []).map((county: any) => ({
            id: county.id,
            name: county.name,
            parishs: county.parishs,
          })),
        );
      });
    }

    if (Array.isArray(countyIds) && countyIds.length > 0) {
      const selectedCounties = this.counties.filter((county: any) =>
        countyIds.includes(county.id),
      );
      selectedCounties.forEach((county: any) => {
        this.parish.push(
          ...(county.parishs || []).map((parish: any) => ({
            id: parish.id,
            name: parish.name,
          })),
        );
      });
    }
  }

  private resolveStatusIdFromFilters(filters: Partial<PropertyFiltersModel>) {
    if (Array.isArray(filters?.businessStatus) && filters.businessStatus.length === 1) {
      return filters.businessStatus[0];
    }

    if (filters?.inProspecting === true) {
      return this.businessStatus?.find((status: any) => status?.code === "PROSPECTING")?.id || null;
    }

    return null;
  }

  private applyDefaultBusinessStatusFilter() {
    if (!this.propertiesFiltersForm) return;

    const availableId = this.getAvailableBusinessStatusId();
    this.selectedStatusId = availableId;
    this.patchBusinessStatusSelection(availableId);
    this.updateQuickFilterState();
  }

  private patchBusinessStatusSelection(statusId: any) {
    if (!this.propertiesFiltersForm) return;

    const data: any = {};
    for (const status of this.businessStatus || []) {
      data[`businessStatus_${status.id}`] = this.isSameQuickFilterValue(status.id, statusId);
    }

    this.propertiesFiltersForm.patchValue(data);
  }

  private getAvailableBusinessStatusId() {
    return this.businessStatus?.find((status: any) => status?.code === "AVAILABLE")?.id || null;
  }

  private getSelectedBusinessStatusIds() {
    return (this.businessStatus || [])
      .filter((status: any) => this.propertiesFiltersForm?.get(`businessStatus_${status.id}`)?.value === true)
      .map((status: any) => status.id);
  }

  private cloneSavedFilterData<T>(value: T): T {
    return JSON.parse(JSON.stringify(value || {}));
  }

  /**
   * Com o contexto global de agência, o filtro "Agência" fica sempre na
   * agência do topbar (formulário e pedido). Sem contexto não faz nada.
   */
  private applyAgencyStoreLock() {
    if (!this.lockedStores.length) return;

    if (this.propertyFilters) {
      this.propertyFilters.stores = [...this.lockedStores];
    }
    const storesControl = this.propertiesFiltersForm?.get("stores");
    const current = storesControl?.value;
    if (
      storesControl &&
      !(
        Array.isArray(current) &&
        current.length === this.lockedStores.length &&
        current.every((id: any) => this.lockedStores.includes(Number(id)))
      )
    ) {
      storesControl.patchValue([...this.lockedStores]);
    }
  }

  resetPropertiesFiltersForm() {
    this.propertiesFiltersForm.reset();
    // Limpar não remove a agência do topbar.
    this.applyAgencyStoreLock();
    this.propertiesFiltersForm.patchValue({ minPrice: this.minPrice });
    this.propertiesFiltersForm.patchValue({ maxPrice: this.maxPrice });
    this.propertiesFiltersForm.patchValue({
      websiteStatus: false,
      websiteHighlight: false,
    });
    for (const condition of this.conditions) {
      const data: any = {};
      data[`condition_${condition.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }
    for (const bStatus of this.filtersBusinessStatus) {
      const data: any = {};
      data[`businessStatus_${bStatus.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }

    for (const bTypes of this.businessTypes) {
      const data: any = {};
      data[`businessTypes_${bTypes.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }

    for (const ec of this.ecs) {
      const data: any = {};
      data[`ec_${ec.id}`] = false;
      this.propertiesFiltersForm.patchValue(data);
    }
  }

  filtersProperties(isTotalfilters = false) {
    const data: any = {};

    if (
      Array.isArray(this.propertiesFiltersForm.get(`stores`)?.value) &&
      this.propertiesFiltersForm.get(`stores`)?.value.length > 0
    ) {
      // data['stores'] = this.propertiesFiltersForm.get(`stores`)?.value;
      this.propertyFilters.stores =
        this.propertiesFiltersForm.get(`stores`)?.value;
    } else {
      this.propertyFilters.stores = undefined;
    }
    this.applyAgencyStoreLock();

    if (
      Array.isArray(this.propertiesFiltersForm.get(`propertyTypes`)?.value) &&
      this.propertiesFiltersForm.get(`propertyTypes`)?.value.length > 0
    ) {
      // data['propertyTypes']
      this.propertyFilters.propertyTypes =
        this.propertiesFiltersForm.get(`propertyTypes`)?.value;
    } else {
      this.propertyFilters.propertyTypes = undefined;
    }

    if (
      this.propertiesFiltersForm.get(`minUsefulArea`)?.value !== null ||
      this.propertiesFiltersForm.get(`maxUsefulArea`)?.value !== null
    ) {
      // data['usefulArea']
      this.propertyFilters.usefulArea = {
        min:
          this.propertiesFiltersForm.get(`minUsefulArea`)?.value !== null
            ? this.propertiesFiltersForm.get(`minUsefulArea`)?.value
            : 0,
        max: this.propertiesFiltersForm.get(`maxUsefulArea`)?.value,
      };
    } else {
      this.propertyFilters.usefulArea = undefined;
    }

    if (
      this.propertiesFiltersForm.get(`minYearofconstruction`)?.value !== null ||
      this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value !== null
    ) {
      // data['yearofconstruction']
      this.propertyFilters.yearofconstruction = {
        min:
          this.propertiesFiltersForm.get(`minYearofconstruction`)?.value !==
          null
            ? this.propertiesFiltersForm.get(`minYearofconstruction`)?.value
            : 0,
        max: this.propertiesFiltersForm.get(`maxYearofconstruction`)?.value,
      };
    } else {
      this.propertyFilters.yearofconstruction = undefined;
    }

    if (
      this.propertiesFiltersForm.get(`minCreatedAt`)?.value ||
      this.propertiesFiltersForm.get(`maxCreatedAt`)?.value
    ) {
      this.propertyFilters.createdAt = {
        min: this.propertiesFiltersForm.get(`minCreatedAt`)?.value || undefined,
        max: this.propertiesFiltersForm.get(`maxCreatedAt`)?.value || undefined,
      };
    } else {
      this.propertyFilters.createdAt = undefined;
    }

    if (
      this.propertiesFiltersForm.get(`minUpdatedAt`)?.value ||
      this.propertiesFiltersForm.get(`maxUpdatedAt`)?.value
    ) {
      this.propertyFilters.updatedAt = {
        min: this.propertiesFiltersForm.get(`minUpdatedAt`)?.value || undefined,
        max: this.propertiesFiltersForm.get(`maxUpdatedAt`)?.value || undefined,
      };
    } else {
      this.propertyFilters.updatedAt = undefined;
    }

    if (
      this.propertiesFiltersForm.get(`minValidatedAt`)?.value ||
      this.propertiesFiltersForm.get(`maxValidatedAt`)?.value
    ) {
      this.propertyFilters.validatedAt = {
        min:
          this.propertiesFiltersForm.get(`minValidatedAt`)?.value || undefined,
        max:
          this.propertiesFiltersForm.get(`maxValidatedAt`)?.value || undefined,
      };
    } else {
      this.propertyFilters.validatedAt = undefined;
    }

    if (
      this.propertiesFiltersForm.get(`minPrice`)?.value !== this.minPrice ||
      this.propertiesFiltersForm.get(`maxPrice`)?.value !== this.maxPrice
    ) {
      // data['price']
      this.propertyFilters.price = {
        min:
          this.propertiesFiltersForm.get(`minPrice`)?.value !== null
            ? this.propertiesFiltersForm.get(`minPrice`)?.value
            : 0,
        max: this.propertiesFiltersForm.get(`maxPrice`)?.value,
      };
    } else {
      this.propertyFilters.price = undefined;
    }

    const dataFormC = this.conditions.filter((e: any) => {
      return (
        this.propertiesFiltersForm.get(`condition_${e.id}`)?.value === true
      );
    });

    if (dataFormC?.length > 0) {
      // data['conditions']
      this.propertyFilters.conditions = dataFormC.map((e: any) => e.id); //map
    } else {
      this.propertyFilters.conditions = undefined;
    }

    const dataFormBs = this.businessStatus.filter((e: any) => {
      return (
        this.propertiesFiltersForm.get(`businessStatus_${e.id}`)?.value === true
      );
    });

    if (dataFormBs?.length > 0) {
      // data['businessStatus']
      this.propertyFilters.businessStatus = dataFormBs.map((e: any) => e.id);
    } else {
      this.propertyFilters.businessStatus = undefined;
    }

    const dataFormBt = this.businessTypes.filter((e: any) => {
      return (
        this.propertiesFiltersForm.get(`businessTypes_${e.id}`)?.value === true
      );
    });

    if (dataFormBt?.length > 0) {
      // data['businessTypes']
      this.propertyFilters.businessTypes = dataFormBt.map((e: any) => e.id);
    } else {
      this.propertyFilters.businessTypes = undefined;
    }

    const dataFormEC = this.ecs.filter((e: any) => {
      return this.propertiesFiltersForm.get(`ec_${e.id}`)?.value === true;
    });

    if (dataFormEC?.length > 0) {
      // data['ecs']
      this.propertyFilters.ecs = dataFormEC.map((e: any) => e.id);
    } else {
      this.propertyFilters.ecs = undefined;
    }

    if (this.propertiesFiltersForm.get(`showNetworkProperties`)) {
      this.propertyFilters.showNetworkProperties =
        this.propertiesFiltersForm.get(`showNetworkProperties`)?.value;
    } else {
      this.propertyFilters.showNetworkProperties = undefined;
    }

    if (this.propertiesFiltersForm.get(`showStoreProperties`)) {
      this.propertyFilters.showStoreProperties =
        this.propertiesFiltersForm.get(`showStoreProperties`)?.value;
    } else {
      this.propertyFilters.showStoreProperties = undefined;
    }

    // Só vai a `true` para o STORE OPERATOR em "Os meus imóveis".
    this.propertyFilters.showMyProperties =
      this.propertiesFiltersForm.get(`showMyProperties`)?.value === true
        ? true
        : undefined;

    if (
      Array.isArray(this.propertiesFiltersForm.get(`agents`)?.value) &&
      this.propertiesFiltersForm.get(`agents`)?.value.length > 0
    ) {
      this.propertyFilters.agents =
        this.propertiesFiltersForm.get(`agents`)?.value;
    } else {
      this.propertyFilters.agents = undefined;
    }

    if (this.propertiesFiltersForm.get(`listingAgent`)?.value === true) {
      this.propertyFilters.listingAgent =
        this.propertiesFiltersForm.get(`listingAgent`)?.value;
    } else {
      this.propertyFilters.listingAgent = undefined;
    }

    if (this.propertiesFiltersForm.get(`secondaryAgent`)?.value === true) {
      this.propertyFilters.secondaryAgent =
        this.propertiesFiltersForm.get(`secondaryAgent`)?.value;
    } else {
      this.propertyFilters.secondaryAgent = undefined;
    }

    if (
      this.propertiesFiltersForm.get("district")?.value &&
      this.propertiesFiltersForm.get("district")?.value?.length > 0
    ) {
      this.propertyFilters.district =
        this.propertiesFiltersForm.get("district")?.value;
    } else {
      this.propertyFilters.district = undefined;
    }

    if (
      this.propertiesFiltersForm.get("county")?.value &&
      this.propertiesFiltersForm.get("county")?.value?.length > 0
    ) {
      this.propertyFilters.county =
        this.propertiesFiltersForm.get("county")?.value;
    } else {
      this.propertyFilters.county = undefined;
    }

    if (
      this.propertiesFiltersForm.get("parish")?.value &&
      this.propertiesFiltersForm.get("parish")?.value?.length > 0
    ) {
      this.propertyFilters.parish =
        this.propertiesFiltersForm.get("parish")?.value;
    } else {
      this.propertyFilters.parish = undefined;
    }

    if (this.propertiesFiltersForm.get("typology")?.value?.length > 0) {
      this.propertyFilters.typology =
        this.propertiesFiltersForm.get("typology")?.value;
    } else {
      this.propertyFilters.typology = undefined;
    }

    if (this.propertiesFiltersForm.get("exclusive")?.value) {
      this.propertyFilters.exclusive =
        this.propertiesFiltersForm.get("exclusive")?.value;
    } else {
      this.propertyFilters.exclusive = undefined;
    }

    if (
      this.portalExportError?.status ||
      this.propertiesFiltersForm.get("websiteStatus")?.value === true
    ) {
      this.propertyFilters.status = true;
    } else {
      this.propertyFilters.status = undefined;
    }

    if (this.propertiesFiltersForm.get("websiteHighlight")?.value === true) {
      this.propertyFilters.highlight = true;
    } else {
      this.propertyFilters.highlight = undefined;
    }

    if (!isTotalfilters) {
      this.closeFilters(false);
      this.refreshProperties();
    }
  }

  closeFilters(isReset = true) {
    this.closePropertyfiltersRef.nativeElement.click();
    setTimeout(() => {
      // if (isReset && this.countFilters$.getValue() === 0)
      //   this.resetPropertiesFiltersForm();
      this.showPropertyFilerts = false;
    }, 100);
  }

  openFilters() {
    this.bkpFiltersForm = this.propertiesFiltersForm.value;
  }

  closeCanvas(el: HTMLElement | null, whitoutFilter: boolean = false) {
    this.showPropertyFilerts = false;
    if (el) {
      el.click();
    } else {
      document.getElementById("closeCBtn")?.click();
    }
    if (whitoutFilter) {
      this.propertiesFiltersForm.setValue(this.bkpFiltersForm);
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    const bProp = this.properties.map((p) => p);
    moveItemInArray(this.properties, event.previousIndex, event.currentIndex);
    const data: any[] = [];
    this.properties.forEach((p, i) => {
      data.push({ id: p.id, order: i + 1 });
    });
    if (data.length > 0) {
      this.propertiesService.updatePropertiesOrder(data).subscribe({
        next: () => {},
        error: () => {
          this.properties = bProp;
          this.errorMsg("");
        },
      });
    }
  }

  private resetScroll() {
    setTimeout(() => {
      if (this.portalExportError?.status) {
        const modalElement = document.querySelector(".modal-body");
        if (modalElement) {
          modalElement.scrollTop = 0;
        }
      } else {
        window.scrollTo(0, 0);
      }
    });
  }

  onImageError(event: any) {
    event.target.src = "assets/images/no-image-available1_1.jpeg";
  }

  onUserImageError(event: any) {
    event.target.src = "assets/images/users/user-dummy-img.jpg";
  }

  toastClosed() {
    this.toastsTitle = "";
    this.toastsText = "";
    this.toastsPercentage = 0;
    this.showToasts = false;
  }

  changeTab(event: any) {
    if (event === 1) {
      this.loadData();
    }
  }

  openPreviewModal(content: any, property: any) {
    this.propertyToPreview = property?.preview;
    this.entityId = this.propertyToPreview?.entityId;
    this.fullPropertyToPreview = property;
    this.resetPropertyNotesState();
    this.loadPropertyNotesAccess();
    this.trackPreviewOpened(property?.id ?? property?.preview?.propertyId);

    return this.modalService.open(content, this.previewModalOptions());
  }

  /**
   * O preview também serve para mostrar o imóvel ao cliente: em ecrã inteiro
   * no telemóvel e sem fechar com o Esc que fecha a imagem ampliada.
   */
  private previewModalOptions(): NgbModalOptions {
    return {
      size: "xl",
      centered: true,
      scrollable: true,
      backdrop: "static",
      modalDialogClass: "modal-fullscreen-md-down",
      beforeDismiss: () => !this.previewLightboxOpen,
    };
  }

  /** Abre as imagens do preview inteiras, a começar pela tocada. */
  openPreviewImage(index: number) {
    const album: IAlbum[] = (this.propertyToPreview?.images ?? [])
      .filter((image) => !!image?.url)
      .map((image) => ({
        src: this.pathImage + image.url,
        thumb: this.pathImage + image.url,
        caption: image.description || "",
      }));
    if (album.length === 0) return;

    this.previewLightboxOpen = true;
    const closeSub = this.lightboxEvent.lightboxEvent$.subscribe(
      (event: any) => {
        if (event?.id !== LIGHTBOX_EVENT.CLOSE) return;
        // O Esc do lightbox é `keyup`; o do modal é `keydown` e decide num
        // requestAnimationFrame — só baixar a guarda depois disso.
        setTimeout(() => (this.previewLightboxOpen = false));
        closeSub.unsubscribe();
      },
    );

    this.lightbox.open(album, Math.min(Math.max(index, 0), album.length - 1), {
      wrapAround: true,
      centerVertically: true,
      alwaysShowNavOnTouchDevices: true,
      disableScrolling: true,
      showImageNumberLabel: true,
      albumLabel: "%1 / %2",
    });
  }

  onPreviewTouchStart(event: TouchEvent) {
    const touch = event.touches?.[0];
    this.previewTouchStart = touch
      ? { x: touch.clientX, y: touch.clientY }
      : null;
  }

  /** Deslizar na horizontal muda de imagem; na vertical deixa fazer scroll. */
  onPreviewTouchEnd(event: TouchEvent, carousel: NgbCarousel) {
    const start = this.previewTouchStart;
    this.previewTouchStart = null;
    const touch = event.changedTouches?.[0];
    if (!start || !touch || !carousel) return;

    const dx = touch.clientX - start.x;
    const dy = touch.clientY - start.y;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

    if (dx < 0) carousel.next();
    else carousel.prev();
  }

  getPropertyToPreview(propertyId: any) {
    this.propertiesService.findPrevById(propertyId).subscribe((data: any) => {
      if (data && data?.preview) {
        if (this.autoOpenEditFromPreview) {
          this.propertyToPreview = data?.preview;
          this.fullPropertyToPreview = data;
          this.openModal(this.fullPropertyToPreview);
          return;
        }

        this.propertyToPreview = data?.preview;
        this.fullPropertyToPreview = data;
        this.entityId = this.propertyToPreview?.entityId;
        this.resetPropertyNotesState();
        this.loadPropertyNotesAccess();
        this.trackPreviewOpened(data?.id ?? data?.preview?.propertyId);
        this.modalPreviewRef = this.modalService.open(
          this.modalPreview,
          this.previewModalOptions(),
        );

        this.modalPreviewRef.closed.subscribe(() => {
          if (this.editingFromEmbeddedPreview) return;
          this.closeModalPreview.emit(true);
        });

        this.modalPreviewRef.dismissed.subscribe(() => {
          if (this.editingFromEmbeddedPreview) return;
          this.closeModalPreview.emit(true);
        });
      }
    });
  }

  editPropertyByPreview() {
    // Só relevante em modo embebido; na página de imóveis o emit não tem
    // ouvinte que destrua o componente.
    if (this.openPreview) {
      this.editingFromEmbeddedPreview = true;
    }
    if (this.fractionPreviewFromDev) {
      this.eventService.broadcast("close-dev-preview");
    }
    this.openModal(this.fullPropertyToPreview);
  }

  private loadEntitySettings() {
    this.entityService.getEntityForProposal().subscribe({
      next: (entity) => {
        this.enablePropertyNotes = !!entity?.enablePropertyNotes;
        this.showMinCommissionPendingFilter =
          this.permissionsService.isRealMaster(this.loginUser?.role?.name) &&
          Number(entity?.minimumSaleCommission) > 0 &&
          entity?.minimumCommissionViolationAction ===
            "SEND_TO_MASTER_VALIDATION";
      },
    });
  }

  // Só mostra o switch a quem pode editar imóveis e tem, no seu escopo,
  // pelo menos um imóvel com freguesia desatualizada
  private loadOutdatedParishFilterVisibility() {
    if (!this.permissionsService.hasPermission("EDIT_PROPERTIES")) return;
    this.propertiesService.hasOutdatedParishProperties().subscribe({
      next: (data) => {
        this.showOutdatedParishFilter = data?.exists === true;
      },
    });
  }

  togglePropertyNotes() {
    if (!this.enablePropertyNotes) return;

    this.propertyNotesExpanded = !this.propertyNotesExpanded;
    if (this.propertyNotesExpanded && this.propertyNotes.length === 0) {
      this.loadPropertyNotes();
    }
  }

  addPropertyNote() {
    const propertyId = this.getCurrentPreviewPropertyId();
    const description = this.newPropertyNote?.trim();
    const hasFiles = this.propertyNoteFilesToUpload.length > 0;

    if (!propertyId || (!description && !hasFiles) || this.propertyNotesSaving)
      return;

    const formData = new FormData();
    if (description) {
      formData.append("description", description);
    }

    this.propertyNoteFilesToUpload.forEach((file) => {
      formData.append("files", file, file.name);
    });

    this.propertyNotesSaving = true;
    this.propertiesService.createPropertyNote(propertyId, formData).subscribe({
      next: (note) => {
        this.newPropertyNote = "";
        this.propertyNoteFilesToUpload = [];
        this.clearPropertyNoteFilesInput();
        this.propertyNotes.unshift(note);
        this.propertyNotesSaving = false;
      },
      error: () => {
        this.propertyNotesSaving = false;
        this.errorMsg(this.translate.instant("t-something-wrong"));
      },
    });
  }

  formatPropertyNoteDate(date: any) {
    return date ? new Date(date).toLocaleString("pt-PT") : "-";
  }

  onPropertyNoteFilesSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    const files = Array.from(target?.files || []);
    this.propertyNoteFilesToUpload = files;
  }

  getPropertyNoteFileUrl(note: any, file: any) {
    const propertyId = note?.propertyId || this.getCurrentPreviewPropertyId();
    if (!propertyId || !file?.fileName) return null;
    return `${environment.apiUrl}/properties/${propertyId}/notes/files/${encodeURIComponent(file.fileName)}`;
  }

  private loadPropertyNotes() {
    const propertyId = this.getCurrentPreviewPropertyId();
    if (!propertyId) {
      this.errorMsg(this.translate.instant("t-something-wrong"));
      return;
    }

    this.propertyNotesLoading = true;
    this.propertiesService.getPropertyNotes(propertyId).subscribe({
      next: (notes) => {
        this.propertyNotes = notes ?? [];
        this.propertyNotesLoading = false;
      },
      error: () => {
        this.propertyNotesLoading = false;
        this.errorMsg(this.translate.instant("t-something-wrong"));
      },
    });
  }

  private getCurrentPreviewPropertyId() {
    return (
      this.fullPropertyToPreview?.id ??
      (this.propertyToPreview as any)?.propertyId
    );
  }

  private resetPropertyNotesState() {
    this.propertyNotesExpanded = false;
    this.propertyNotesLoading = false;
    this.propertyNotesSaving = false;
    this.propertyNotes = [];
    this.newPropertyNote = "";
    this.propertyNoteFilesToUpload = [];
    this.propertyNotesAccess = null;
    this.clearPropertyNoteFilesInput();
  }

  /**
   * Pergunta ao servidor se este imóvel tem notas legíveis/editáveis por
   * quem está autenticado. Enquanto não responde (ou se falhar) o bloco de
   * notas fica escondido — um imóvel MLS ou fora do âmbito nunca mostra o
   * botão que ia dar erro.
   */
  private loadPropertyNotesAccess() {
    const propertyId = this.getCurrentPreviewPropertyId();
    if (!propertyId) return;

    this.propertiesService.getPropertyNotesAccess(propertyId).subscribe({
      next: (access) => {
        if (this.getCurrentPreviewPropertyId() !== propertyId) return;
        this.propertyNotesAccess = access ?? { canRead: false, canWrite: false };
      },
      error: () => {
        if (this.getCurrentPreviewPropertyId() !== propertyId) return;
        this.propertyNotesAccess = { canRead: false, canWrite: false };
      },
    });
  }

  private clearPropertyNoteFilesInput() {
    if (this.propertyNotesFileInput?.nativeElement) {
      this.propertyNotesFileInput.nativeElement.value = "";
    }
  }

  OpenModalMontra(propertyToPreview: any) {
    this.modalService.dismissAll();

    this.modalMontraRef = this.modalService.open(this.modalMontra, {
      size: "lg",
      centered: true,
      scrollable: true,
      backdrop: "static",
    });

    this.modalMontraRef.closed.subscribe(() => {
      this.closeModalPreview.emit(true);
    });

    this.modalMontraRef.dismissed.subscribe(() => {
      this.closeModalPreview.emit(true);
    });

    const agent = propertyToPreview.agent;
    const store = propertyToPreview.store;
    const defaultLayout = this.getDefaultShowcaseLayout();

    this.montraForm.patchValue({
      title: propertyToPreview.title,
      subTitle: "",
      description: this.cleanText(propertyToPreview.description),
      templateType: defaultLayout
        ? defaultLayout.format === "VERTICAL"
          ? "vertical"
          : "horizontal"
        : "vertical",
      layoutId: defaultLayout?.id ?? null,
      layoutCode: defaultLayout?.code ?? null,
      price: propertyToPreview.price
        ? this.priceFormat(propertyToPreview.price)
        : null,
      agentName: agent?.name ?? store?.name,
      agentPhone: agent?.phone ?? store?.phone,
      agentEmail: agent?.email ?? store?.email,
      agentImage: agent?.image ? this.pathUserImage + agent.image : null,
      reference: propertyToPreview.reference,
      energeticClass: propertyToPreview?.ec,
      area: propertyToPreview?.usefulArea,
      zone: propertyToPreview?.county,
      propertyId: propertyToPreview?.propertyId,
      storeId: propertyToPreview?.store.id,
      appId: propertyToPreview?.appId,
      ami: propertyToPreview.store?.licenseImo,
      companyName: store?.companyName,
    });

    if (defaultLayout) {
      this.selectShowcaseLayout(defaultLayout, false);
    }
  }

  cleanText(html: string): string {
    return (
      html
        ?.replace(/<\/p>/gi, "\n")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<[^>]*>/g, "")
        .trim() ?? ""
    );
  }

  private loadShowcaseLayouts() {
    this.showcaseLayoutsLoading = true;
    const showcaseLayoutsSubscription = this.entityService
      .getShowcaseLayouts()
      .subscribe({
        next: (layouts) => {
          this.showcaseLayouts = layouts ?? [];
          const defaultLayout = this.getDefaultShowcaseLayout();
          if (defaultLayout && this.montraForm) {
            this.selectShowcaseLayout(defaultLayout, false);
          }
          this.showcaseLayoutsLoading = false;
        },
        error: () => {
          this.showcaseLayouts = [];
          this.showcaseLayoutsLoading = false;
        },
      });

    this.subscriptions.add(showcaseLayoutsSubscription);
  }

  private getDefaultShowcaseLayout() {
    if (!this.showcaseLayouts.length) {
      return null;
    }

    return (
      this.showcaseLayouts.find((layout) => layout.isDefault) ??
      this.showcaseLayouts[0]
    );
  }

  buildShowcasePreviewUrl(layout: ShowcaseLayoutModel) {
    return layout.previewPath
      ? `${environment.apiUrl}${layout.previewPath}`
      : null;
  }

  openShowcaseLayoutPreview(event: Event, layout: ShowcaseLayoutModel) {
    const previewUrl = this.buildShowcasePreviewUrl(layout);
    if (!previewUrl) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    window.open(previewUrl, "_blank", "noopener,noreferrer");
  }

  getShowcaseImagesRangeLabel(minImages: number, maxImages: number) {
    if (minImages === maxImages) {
      return this.getShowcaseImageCountLabel(maxImages);
    }

    return this.translateService.instant(
      "t-showcase-layouts.t-images-range-label",
      { min: minImages, max: maxImages },
    );
  }

  getSelectedShowcaseImagesHint() {
    if (this.showcaseMinImages === this.showcaseMaxImages) {
      return this.translateService.instant(
        this.showcaseMaxImages === 1
          ? "t-showcase-layouts.t-images-hint-exact-singular"
          : "t-showcase-layouts.t-images-hint-exact-plural",
        { count: this.showcaseMaxImages },
      );
    }

    return this.translateService.instant(
      "t-showcase-layouts.t-images-hint-range",
      { min: this.showcaseMinImages, max: this.showcaseMaxImages },
    );
  }

  selectShowcaseLayout(layout: ShowcaseLayoutModel, resetImages = true) {
    this.selectedShowcaseLayout = layout;
    this.montraForm.patchValue({
      layoutId: layout.id,
      layoutCode: layout.code,
      templateType: layout.format === "VERTICAL" ? "vertical" : "horizontal",
    });

    this.applyShowcaseLayoutValidators(layout);

    if (!layout.hasSubTitle) {
      this.montraForm.patchValue({ subTitle: "" });
    }

    if (resetImages) {
      this.imagesFormArray.clear();
    }
  }

  private applyShowcaseLayoutValidators(layout: ShowcaseLayoutModel) {
    const titleValidators = [];
    if (layout.hasTitle) {
      titleValidators.push(Validators.required);
    }
    if (layout.titleMaxLength) {
      titleValidators.push(Validators.maxLength(layout.titleMaxLength));
    }

    const subTitleValidators = [];
    if (layout.hasSubTitle && layout.subTitleMaxLength) {
      subTitleValidators.push(Validators.maxLength(layout.subTitleMaxLength));
    }

    const descriptionValidators = [Validators.required];
    if (layout.descriptionMaxLength) {
      descriptionValidators.push(
        Validators.maxLength(layout.descriptionMaxLength),
      );
    }

    const zoneValidators = [];
    if (layout.zoneMaxLength) {
      zoneValidators.push(Validators.maxLength(layout.zoneMaxLength));
    }

    this.montraForm.get("title")?.setValidators(titleValidators);
    this.montraForm.get("subTitle")?.setValidators(subTitleValidators);
    this.montraForm.get("description")?.setValidators(descriptionValidators);
    this.montraForm.get("zone")?.setValidators(zoneValidators);

    this.montraForm.get("title")?.updateValueAndValidity({ emitEvent: false });
    this.montraForm
      .get("subTitle")
      ?.updateValueAndValidity({ emitEvent: false });
    this.montraForm
      .get("description")
      ?.updateValueAndValidity({ emitEvent: false });
    this.montraForm.get("zone")?.updateValueAndValidity({ emitEvent: false });
  }

  saveMontra() {
    if (!this.hasValidShowcaseImageCount) {
      Swal.fire({
        title: this.translateService.instant("t-something-wrong"),
        text: this.getShowcaseImagesValidationMessage(),
        icon: "warning",
        confirmButtonColor: "rgb(54, 69, 116)",
        confirmButtonText: this.translateService.instant("t-close"),
      });
      return;
    }

    if (this.montraForm.invalid) {
      this.montraForm.markAllAsTouched();
      Swal.fire({
        title: this.translateService.instant("t-something-wrong"),
        text: this.translateService.instant(
          "t-properties-showcase-description-invalid",
        ),
        icon: "warning",
        confirmButtonColor: "rgb(54, 69, 116)",
        confirmButtonText: this.translateService.instant("t-close"),
      });
      return;
    }

    const body = this.montraForm.value;

    this.isLoadingShowcase = true;

    this.propertiesService.createShowcaseSheet(body).subscribe({
      next: (blob: Blob) => {
        this.isLoadingShowcase = false;


        // const fileURL = URL.createObjectURL(blob)
        // window.open(fileURL, '_blank')

        const fileURL = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = fileURL;
        a.download = `${this.propertyToPreview?.reference}.pdf`;
        a.click();

        Swal.fire({
          title: this.translateService.instant("t-showcase-generated"),
          text: this.translateService.instant("t-showcase-generated-description"),
          icon: "success",
          confirmButtonColor: "rgb(54, 69, 116)",
          confirmButtonText: this.translateService.instant("t-close"),
        })

        // this.modalMontraRef.close();
        // this.resetShowcaseFormState();
      },
      error: (error) => {
        this.isLoadingShowcase = false;
        Swal.fire({
          title: this.translateService.instant("t-something-wrong"),
          icon: "warning",
          confirmButtonColor: "rgb(54, 69, 116)",
          confirmButtonText: this.translateService.instant("t-close"),
        });
      },
    });
  }

  get imagesFormArray(): FormArray {
    return this.montraForm.get("images") as FormArray;
  }

  get selectedShowcaseImagesCount(): number {
    return this.imagesFormArray.length;
  }

  get showcaseMinImages(): number {
    return this.selectedShowcaseLayout?.minImages ?? 4;
  }

  get showcaseMaxImages(): number {
    return this.selectedShowcaseLayout?.maxImages ?? 4;
  }

  get hasValidShowcaseImageCount(): boolean {
    return (
      this.selectedShowcaseImagesCount >= this.showcaseMinImages &&
      this.selectedShowcaseImagesCount <= this.showcaseMaxImages
    );
  }

  get canGenerateShowcase(): boolean {
    return (
      !!this.selectedShowcaseLayout &&
      this.montraForm.valid &&
      this.hasValidShowcaseImageCount &&
      !this.isLoadingShowcase
    );
  }

  isImageSelected(image: any): boolean {
    return this.imagesFormArray.controls.some(
      (ctrl) => ctrl.value?.url === image?.url,
    );
  }

  toggleImageSelection(image: any) {
    if (this.isImageSelected(image)) {
      this.removeShowcaseImage(image);
      return;
    }

    this.addShowcaseImage(image);
  }

  private mapShowcaseImageWithPath(image: any) {
    const pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
    return {
      ...image,
      fullUrl: `${pathImage}${image.url}`,
    };
  }

  private addShowcaseImage(image: any): boolean {
    if (this.selectedShowcaseImagesCount >= this.showcaseMaxImages) {
      Swal.fire({
        title: this.translateService.instant("t-something-wrong"),
        text: this.getShowcaseImagesValidationMessage(),
        icon: "warning",
        confirmButtonColor: "rgb(54, 69, 116)",
        confirmButtonText: this.translateService.instant("t-close"),
      });
      return false;
    }

    this.imagesFormArray.push(
      this.formBuilder.control(this.mapShowcaseImageWithPath(image)),
    );
    return true;
  }

  private removeShowcaseImage(image: any) {
    const index = this.imagesFormArray.controls.findIndex(
      (ctrl) => ctrl.value?.url === image?.url,
    );

    if (index !== -1) {
      this.imagesFormArray.removeAt(index);
    }
  }

  toggleImage(image: any, event: Event) {
    event.stopPropagation();
    const checked = (event.target as HTMLInputElement).checked;

    if (checked) {
      const added = this.addShowcaseImage(image);
      if (!added) {
        (event.target as HTMLInputElement).checked = false;
      }
    } else {
      this.removeShowcaseImage(image);
    }
  }

  closeModalMontra() {
    this.resetShowcaseFormState();
  }

  private resetShowcaseFormState() {
    this.imagesFormArray.clear();
    const defaultLayout = this.getDefaultShowcaseLayout();
    this.selectedShowcaseLayout = defaultLayout;
    this.montraForm.reset({
      templateType: defaultLayout
        ? defaultLayout.format === "VERTICAL"
          ? "vertical"
          : "horizontal"
        : "vertical",
      layoutId: defaultLayout?.id ?? null,
      layoutCode: defaultLayout?.code ?? null,
    });

    if (defaultLayout) {
      this.applyShowcaseLayoutValidators(defaultLayout);
    }
  }

  private getShowcaseImagesValidationMessage() {
    if (this.showcaseMinImages === this.showcaseMaxImages) {
      return this.translateService.instant(
        this.showcaseMaxImages === 1
          ? "t-showcase-layouts.t-images-validation-exact-singular"
          : "t-showcase-layouts.t-images-validation-exact-plural",
        { count: this.showcaseMaxImages },
      );
    }

    return this.translateService.instant(
      "t-showcase-layouts.t-images-validation-range",
      { min: this.showcaseMinImages, max: this.showcaseMaxImages },
    );
  }

  private getShowcaseImageCountLabel(count: number) {
    return this.translateService.instant(
      count === 1
        ? "t-showcase-layouts.t-images-count-singular"
        : "t-showcase-layouts.t-images-count-plural",
      { count },
    );
  }

  onSort(
    column:
      | "property"
      | "propertyType"
      | "businessType"
      | "price"
      | "store"
      | "status"
      | "updated"
      | "createdAt",
  ) {
    if (this.propertyFilters?.highlight) {
      return;
    }

    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortColumn = column;
      this.sortDirection = "asc";
    }

    this.page = 1;
    this.propertyFilters.page = this.page;
    this.propertyFilters.sortColumn = this.sortColumn || undefined;
    this.propertyFilters.sortDirection = this.sortDirection;
    this.isLoadingList = true;
    this.loadData();
  }

  getSortIndicator(
    column:
      | "property"
      | "propertyType"
      | "businessType"
      | "price"
      | "store"
      | "status"
      | "updated"
      | "createdAt",
  ) {
    if (this.propertyFilters?.highlight) return "";
    if (this.sortColumn !== column) return "↕";
    return this.sortDirection === "asc" ? "↑" : "↓";
  }

  getStores(role: any, val: boolean) {
    if (
      role === "STORE OPERATOR" ||
      role === "AGENT" ||
      role === "COMMERCIAL DIRECTOR"
    ) {
      if (val) {
        // if (!this.allStores || this.allStores.length === 0) {
        //   // this.propertiesService.getStoresByNetwork().subscribe((data: any) => {
        //   //   this.allStores = data;
        //   //   this.stores = data;
        //   // });
        // } else {
        //   this.stores = this.allStores;
        // }
        if (!this.allDistricts || this.allDistricts.length === 0) {
          this.propertiesService
            .getDistrictsByNetwork()
            .subscribe((data: any) => {
              this.allDistricts = data;
              this.districts = data;
            });
        } else {
          this.districts = this.allDistricts;
        }
      } else {
        this.stores = this.storesAux;
        this.districts = this.districtsAux;
      }
    }
  }

  get filtersForm() {
    return this.propertiesFiltersForm.controls;
  }

  /**
   * Inicializa as opções do filtro de âmbito da pesquisa
   */
  initScopeOptions() {
    // Não mostra filtro para MASTER
    if (this.permissionsService.isRealMaster(this.loginUser?.role?.name)) {
      this.scopeOptions = [];
      this.selectedScope = null;
      return;
    }
    this.scopeOptions = [];
    if (this.loginUser?.role?.name === "AGENT") {
      this.scopeOptions.push({ label: "t-my-properties", value: "mine" });
    }
    // Diretor de loja com funções de consultor (interruptor da entidade):
    // ganha "Os meus imóveis", mas o padrão continua a ser a loja.
    const storeOperatorAsConsultant =
      this.loginUser?.role?.name === "STORE OPERATOR" &&
      this.permissionsService.storeOperatorActsAsConsultant();
    if (storeOperatorAsConsultant) {
      this.scopeOptions.push({ label: "t-my-properties", value: "mine" });
    }
    if (this.loginUser?.role?.name === "COMMERCIAL DIRECTOR") {
      this.scopeOptions.push({ label: "t-my-team-properties", value: "mine" });
    }
    this.scopeOptions.push({ label: "t-store-properties", value: "store" });
    if (
      this.permissionsService.hasPermission("VIEW_PROPERTIES_NETWORK") &&
      !this.permissionsService.isRealMaster(this.loginUser?.role?.name)
    ) {
      this.scopeOptions.push({
        label: "t-network-properties",
        value: "network",
      });
    }
    // Valor padrão
    this.selectedScope =
      this.scopeOptions.length > 0 ? this.scopeOptions[0].value : null;
    if (storeOperatorAsConsultant) {
      this.selectedScope = "store";
    }
    this.applyScopeToForm();
  }

  /**
   * Aplica o valor do select de âmbito nos campos do form antigo
   */
  applyScopeToForm() {
    if (!this.propertiesFiltersForm) return;
    // Limpa todos
    this.propertiesFiltersForm.patchValue({
      showStoreProperties: false,
      showNetworkProperties: false,
      showMyProperties: false,
    });
    if (this.selectedScope === "mine") {
      // Meus imóveis: ambos false. Para o STORE OPERATOR o servidor precisa
      // de uma indicação explícita, senão devolve a loja toda.
      this.propertiesFiltersForm.patchValue({
        showStoreProperties: false,
        showNetworkProperties: false,
        showMyProperties: this.loginUser?.role?.name === "STORE OPERATOR",
      });
    } else if (this.selectedScope === "store") {
      this.propertiesFiltersForm.patchValue({
        showStoreProperties: true,
        showNetworkProperties: false,
      });
    } else if (this.selectedScope === "network") {
      this.propertiesFiltersForm.patchValue({
        showStoreProperties: false,
        showNetworkProperties: true,
      });
    }
  }

  selectedPropertyId: any | null = null;
  selectedSection: string | null = null;

  toggleSection(propertyId: any, section: string): void {
    if (
      this.selectedPropertyId === propertyId &&
      this.selectedSection === section
    ) {
      this.selectedPropertyId = null;
      this.selectedSection = null;
      return;
    }

    this.selectedPropertyId = propertyId;
    this.selectedSection = section;
  }

  isSectionOpen(propertyId: any, section: string): boolean {
    return (
      this.selectedPropertyId === propertyId && this.selectedSection === section
    );
  }

  isPropertyExpanded(propertyId: any): boolean {
    return this.selectedPropertyId === propertyId;
  }

  getDataProperty(propertyId: any) {
    this.detailsLoading = true;
    this.propertiesService.getDataProperty(propertyId).subscribe({
      next: (data) => {
        this.dataProperty = data;
        this.buildDetailsRows();
        this.detailsLoading = false;
      },
      error: () => {
        this.dataProperty = [];
        this.buildDetailsRows();
        this.detailsLoading = false;
      },
    });
  }
  /**
   * Handler do select de âmbito
   */
  onScopeChange(event: any) {
    this.selectedScope = event?.value || event;
    this.applyScopeToForm();
  }

  @ViewChild("nav") nav!: NgbNav;

  /**
   * Quem pode abrir cada secção da ficha rápida (Proprietário, Oportunidades,
   * Visitas, Chaves). A regra de sempre é "quem pode editar o imóvel"; um
   * perfil com PROPERTY_OWNERS alargado à entidade abre só o Proprietário
   * de qualquer imóvel. O servidor (`getDataProperty`) decide o que devolve.
   */
  canOpenPropertySection(property: any, tab: string): boolean {
    const canEdit =
      this.permissionsService.checkAgentPermission(
        property?.mainAgent,
        "EDIT_PROPERTIES",
      ) ||
      this.permissionsService.canEditProperty(
        this.loginUser,
        property?.store?.id,
      );

    // Histórico do imóvel: só MASTER e STORE OPERATOR (nas suas agências).
    // O servidor aplica a mesma regra.
    if (tab === "history") {
      const role = this.loginUser?.role?.name;
      return (role === "MASTER" || role === "STORE OPERATOR") && canEdit;
    }

    if (canEdit) return true;

    return (
      tab === "owner" &&
      this.permissionsService.hasEntityDataScope("PROPERTY_OWNERS")
    );
  }

  openPropertyDetailsModal(property: any, tab: string, content: any): void {
    this.selectedProperty = property;
    this.selectedModalTab = tab;
    this.dataProperty = [];
    this.detailsSearch = "";
    this.detailsPage = 1;
    this.buildDetailsRows();
    this.getDataProperty(property.id);

    this.modalRef = this.modalService.open(content, {
      size: "lg",
      centered: true,
      windowClass: "property-details-modal",
    });
  }

  getContactPhone(contact: any): string {
    return (
      contact?.phone ??
      contact?.phoneNumber ??
      contact?.phoneNumber1 ??
      contact?.phoneNumber2 ??
      "-"
    );
  }

  openOwnerContactFromDetails(contactWrapper: any, event?: Event): void {
    event?.stopPropagation();

    const contact = contactWrapper?.contact ?? contactWrapper;
    if (!contact?.id || !this.selectedProperty?.id) {
      return;
    }

    this.modalRef?.dismiss();
    this.menuService.setData({
      menu: "open-owner-contact",
      contact: {
        ...contact,
        propertyRelationContactType: contactWrapper?.contactType,
      },
    });
    this.router.navigate(["contacts"]);
  }

  openDealFromPropertyDetails(lead: any, event?: Event): void {
    event?.stopPropagation();

    const deal = lead?.deal ?? lead;
    const dealId = Number(deal?.id);
    if (!Number.isFinite(dealId) || dealId <= 0) {
      return;
    }

    // Abre o negócio noutro separador: quem está na ficha do imóvel quer
    // espreitar a oportunidade sem perder a lista e os filtros onde estava.
    // A página do negócio é uma rota direta, não precisa do `MenuService`.
    const dealType = this.resolveDealNavigationType(deal);
    const url = this.router.serializeUrl(
      this.router.createUrlTree(["/deals", dealType, dealId]),
    );
    // Sem "noopener" nas features: com ele o `window.open` devolve SEMPRE
    // null (é a especificação) e o código caía no fallback — abria a aba nova
    // E navegava também nesta. O opener é cortado à mão a seguir.
    const opened = window.open(url, "_blank");
    if (opened) {
      opened.opener = null;
      return;
    }

    // Popup bloqueado: cai no comportamento anterior (navega na mesma aba).
    this.modalRef?.dismiss();
    this.menuService.openDealsBoard({
      menu: "open-deal-from-property",
      dealId,
      dealType,
      filterOption: deal?.isWon ? 2 : deal?.isLost ? 3 : 1,
    });
  }

  private resolveDealNavigationType(deal: any): "sale" | "listing" | "process" {
    const type = `${deal?.dealType ?? deal?.type ?? ""}`.trim().toLowerCase();

    if (type === "listing" || type === "process") {
      return type;
    }

    return "sale";
  }

  hasVisits(): boolean {
    return (
      this.dataProperty?.some((item: any) =>
        item?.leads?.some((lead: any) => lead?.visitProperty?.length > 0),
      ) ?? false
    );
  }
  lengthVisits(): boolean {
    return (
      this.dataProperty?.reduce((total: number, item: any) => {
        return (
          total +
          (item?.leads?.filter((lead: any) => lead?.visitProperty?.length > 0)
            .length || 0)
        );
      }, 0) ?? 0
    );
  }

  changeTabModal(tab: string) {
    this.selectedModalTab = tab;
    this.detailsSearch = "";
    this.detailsPage = 1;
    this.refreshDetailsView();
  }

  // ---------------------------------------------------- ficha rápida (modal)
  // Linhas de cada separador calculadas uma vez quando os dados chegam; a
  // pesquisa e a paginação são locais (as listas são pequenas).

  readonly detailsPageSize = 8;
  detailsLoading = false;
  detailsSearch = "";
  detailsPage = 1;
  detailsRows: Record<string, PropertyDetailsRow[]> = {};
  detailsFiltered: PropertyDetailsRow[] = [];
  detailsPaged: PropertyDetailsRow[] = [];

  get detailsKeys(): { address: string | null; number: string | null } {
    const data = this.dataProperty?.[0];
    return {
      address: data?.keyAddress || null,
      number: data?.keyNumber || null,
    };
  }

  get detailsPlate(): { has: boolean; placedAt: any; removedAt: any } {
    const data = this.dataProperty?.[0];
    return {
      has: !!data?.hasPlate,
      placedAt: data?.platePlacementDate ?? null,
      removedAt: data?.plateRemovalDate ?? null,
    };
  }

  /** Contador do separador; `null` quando não se aplica (Histórico). */
  detailsCount(tab: string): number | null {
    if (tab === "keys") {
      const keys = this.detailsKeys;
      return keys.address || keys.number ? 1 : 0;
    }
    if (tab === "plates") return this.detailsPlate.has ? 1 : 0;
    return this.detailsRows[tab]?.length ?? null;
  }

  onDetailsSearch(value: string): void {
    this.detailsSearch = value ?? "";
    this.detailsPage = 1;
    this.refreshDetailsView();
  }

  onDetailsPageChange(page: number): void {
    this.detailsPage = page;
    this.refreshDetailsView();
  }

  openDetailsRow(row: PropertyDetailsRow, event?: Event): void {
    if (row.kind === "owner") {
      this.openOwnerContactFromDetails(row.source, event);
    } else {
      this.openDealFromPropertyDetails(row.source, event);
    }
  }

  trackDetailsRow(_: number, row: PropertyDetailsRow): string {
    return row.id;
  }

  private buildDetailsRows(): void {
    const owners: PropertyDetailsRow[] = [];
    const opportunities: PropertyDetailsRow[] = [];
    const visits: PropertyDetailsRow[] = [];

    (this.dataProperty ?? []).forEach((item: any) => {
      (item?.contactsCostumersProperties ?? []).forEach((wrapper: any) => {
        const contact = wrapper?.contact;
        const name = this.detailsContactName(contact);
        owners.push({
          id: `owner-${contact?.id ?? owners.length}`,
          kind: "owner",
          name,
          initials: this.detailsInitials(name),
          subtitle: contact?.email || null,
          extra: this.detailsPhone(contact),
          statusKey: contact?.status ? "t-active" : "t-inactive",
          statusText: null,
          statusTone: contact?.status ? "success" : "danger",
          statusIcon: contact?.status
            ? "ri-checkbox-circle-line"
            : "ri-close-circle-line",
          agentName: null,
          agentInitials: null,
          dateLabel: null,
          dateTitle: null,
          source: wrapper,
        });
      });

      (item?.leads ?? []).forEach((lead: any) => {
        const name = this.detailsContactName(lead?.contact);
        const agentName = lead?.user?.name || null;
        const contactInfo =
          lead?.contact?.email || this.detailsPhone(lead?.contact);
        const deal = lead?.deal;
        const status: {
          key: string | null;
          tone: PropertyDetailsRow["statusTone"];
          icon: string;
        } = deal?.isWon
          ? { key: "t-won-status", tone: "success", icon: "ri-trophy-line" }
          : deal?.isLost
          ? { key: "t-lost-status", tone: "muted", icon: "ri-close-line" }
          : { key: null, tone: "primary", icon: "ri-loader-2-line" };

        opportunities.push({
          id: `lead-${lead?.id ?? deal?.id ?? opportunities.length}`,
          kind: "opportunity",
          name,
          initials: this.detailsInitials(name),
          subtitle: contactInfo,
          extra: null,
          statusKey: status.key,
          statusText: status.key ? null : deal?.dealStatus?.name || "-",
          statusTone: status.tone,
          statusIcon: status.icon,
          agentName,
          agentInitials: agentName ? this.detailsInitials(agentName) : null,
          dateLabel: this.detailsRelativeDate(deal?.updatedAt),
          dateTitle: deal?.updatedAt ?? null,
          source: lead,
        });

        (lead?.visitProperty ?? []).forEach((visit: any, index: number) => {
          visits.push({
            id: `visit-${visit?.id ?? `${lead?.id}-${index}`}`,
            kind: "visit",
            name,
            initials: this.detailsInitials(name),
            subtitle: contactInfo,
            extra: null,
            statusKey: visit?.isVisited
              ? "t-property-details-visited"
              : "t-property-details-scheduled",
            statusText: null,
            statusTone: visit?.isVisited ? "success" : "warning",
            statusIcon: visit?.isVisited
              ? "ri-check-double-line"
              : "ri-calendar-event-line",
            agentName,
            agentInitials: agentName ? this.detailsInitials(agentName) : null,
            dateLabel: this.detailsRelativeDate(visit?.startAt),
            dateTitle: visit?.startAt ?? null,
            source: lead,
          });
        });
      });
    });

    this.detailsRows = { owner: owners, opportunities, visits };
    this.refreshDetailsView();
  }

  private refreshDetailsView(): void {
    const rows = this.detailsRows[this.selectedModalTab] ?? [];
    const term = this.detailsNormalize(this.detailsSearch);
    this.detailsFiltered = term
      ? rows.filter((row) =>
          this.detailsNormalize(
            [row.name, row.subtitle, row.extra, row.agentName, row.statusText]
              .filter(Boolean)
              .join(" "),
          ).includes(term),
        )
      : rows;

    const pages = Math.max(
      1,
      Math.ceil(this.detailsFiltered.length / this.detailsPageSize),
    );
    if (this.detailsPage > pages) this.detailsPage = pages;
    const start = (this.detailsPage - 1) * this.detailsPageSize;
    this.detailsPaged = this.detailsFiltered.slice(
      start,
      start + this.detailsPageSize,
    );
  }

  private detailsNormalize(value: string | null | undefined): string {
    return `${value ?? ""}`
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  private detailsContactName(contact: any): string {
    return (
      contact?.fullName ||
      [contact?.firstName, contact?.lastName].filter(Boolean).join(" ") ||
      contact?.email ||
      "-"
    );
  }

  private detailsPhone(contact: any): string | null {
    const phone = this.getContactPhone(contact);
    return phone && phone !== "-" ? phone : null;
  }

  private detailsInitials(name: string | null | undefined): string {
    const parts = `${name ?? ""}`.trim().split(/\s+/).filter(Boolean);
    if (!parts.length || parts[0] === "-") return "?";
    return (
      parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")
    ).toUpperCase();
  }

  /** "Hoje, 14:20" · "Ontem, 11:30" · "23 set., 09:45". */
  private detailsRelativeDate(value: any): string | null {
    if (!value) return null;
    const date = new Date(value);
    if (isNaN(date.getTime())) return null;

    const lang = (this.translate.currentLang || "pt").slice(0, 2);
    const locale = lang === "en" ? "en-GB" : `${lang}-${lang.toUpperCase()}`;
    const time = date.toLocaleTimeString(locale, {
      hour: "2-digit",
      minute: "2-digit",
    });
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    const startOfDate = new Date(date);
    startOfDate.setHours(0, 0, 0, 0);
    const diffDays = Math.round(
      (startOfToday.getTime() - startOfDate.getTime()) / 86400000,
    );

    if (diffDays === 0) {
      return `${this.translate.instant("t-property-history-today")}, ${time}`;
    }
    if (diffDays === 1) {
      return `${this.translate.instant("t-property-history-yesterday")}, ${time}`;
    }
    const day = date.toLocaleDateString(locale, {
      day: "numeric",
      month: "short",
      ...(date.getFullYear() === startOfToday.getFullYear()
        ? {}
        : { year: "numeric" }),
    });
    return `${day}, ${time}`;
  }

  /**
   * Histórico: abrir o preview é uma visita real à ficha (não os pedidos
   * técnicos de carregamento da listagem). Cada abertura tem o seu id de
   * navegação, que também liga as imagens vistas nessa abertura.
   */
  private previewNavigationId: string | null = null;
  private previewPropertyId: string | null = null;
  private previewViewedImages = new Set<number>();

  private trackPreviewOpened(propertyId: string | null | undefined): void {
    if (!propertyId) return;
    this.previewPropertyId = propertyId;
    this.previewNavigationId = this.activityLogsService.newNavigationId();
    this.previewViewedImages.clear();
    this.activityLogsService.trackPropertyEvent(propertyId, {
      action: "PROPERTY_VIEW",
      navigationId: this.previewNavigationId,
      context: "preview",
    });
  }

  /** Imagem mostrada no carrossel do preview (uma vez por imagem e abertura). */
  onPreviewSlide(event: any): void {
    const index = Number(`${event?.current ?? ""}`.replace("ngb-slide-", ""));
    const image = this.propertyToPreview?.images?.[index] as any;
    const fileId = Number(image?.fileId);
    if (
      !this.previewPropertyId ||
      !Number.isFinite(fileId) ||
      fileId <= 0 ||
      this.previewViewedImages.has(fileId)
    ) {
      return;
    }
    this.previewViewedImages.add(fileId);
    this.activityLogsService.trackPropertyEvent(this.previewPropertyId, {
      action: "PROPERTY_IMAGE_VIEWED",
      fileId,
      navigationId: this.previewNavigationId ?? undefined,
      context: "preview",
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
